import {
  orFalse20exmi7skltjp as orFalse,
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  ApiPaginatedResponse21k9qwv83e5dh as ApiPaginatedResponse,
  NetworkJobManager330ytw7ckzld9 as NetworkJobManager,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Long2qws0ah9gnpki as Long,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  equals2au1ep9vhcato as equals,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  toSet2orjxp16sotqu as toSet,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  createFailure8paxfkfa5dc7 as createFailure,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  BooleanSerializer_getInstancet3wtk7fl7i4f as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  get_nullable197rfua9r7fsz as get_nullable,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  IntSerializer_getInstance9scrtcljaiv6 as IntSerializer_getInstance,
  INT_getInstance3cjna3yzozsnp as INT_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  serializer1hwzc6m64v1op as serializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleValueEndpointCacheStrategy2snxed6lorji8 as SimpleValueEndpointCacheStrategy,
  SimpleListEndpointCacheStrategy1m0xsspwu4sws as SimpleListEndpointCacheStrategy,
  SimpleGetEndpointCacheStrategy39ps4f500p69k as SimpleGetEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  Unknown1xcq5nwq6ckcn as Unknown,
  ILocalSource1zuymxsgjvvss as ILocalSource,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleCacheLocalSource3mbicvk11uh40 as SimpleCacheLocalSource,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import {
  DayOfWeek37vs35iepos46 as DayOfWeek,
  DayOfWeek2xlo40o03f5e as DayOfWeek_0,
} from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  named1qn5s3wnxjwbv as named,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiAuthorizedDepartment, 'ApiAuthorizedDepartment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiAuthorizedRole, 'ApiAuthorizedRole', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiCompanySettings, 'ApiCompanySettings', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiDepartment, 'ApiDepartment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiLocation, 'ApiLocation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_4);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiRole, 'ApiRole', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiStation, 'ApiStation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForFunctionReference(ILocalSource$put$ref, VOID, VOID, [1]);
initMetadataForLambda(CompanyRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForInterface(ICompanyAccessor, 'ICompanyAccessor');
initMetadataForClass(CompanyRepository, 'CompanyRepository', VOID, VOID, [ICompanyAccessor]);
initMetadataForLambda(DepartmentRepository$authorizedCacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DepartmentRepository$authorizedCacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForLambda(DepartmentRepository$allCacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DepartmentRepository$allCacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForLambda(DepartmentRepository$getByIdStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForInterface(IDepartmentAccessor, 'IDepartmentAccessor', VOID, VOID, VOID, [1]);
initMetadataForInterface(IDepartmentMutator, 'IDepartmentMutator', VOID, VOID, VOID, [1, 2]);
initMetadataForInterface(IDepartmentInvalidator, 'IDepartmentInvalidator', VOID, VOID, VOID, [0]);
initMetadataForClass(DepartmentRepository, 'DepartmentRepository', VOID, VOID, [IDepartmentAccessor, IDepartmentMutator, IDepartmentInvalidator], [1, 2, 0]);
initMetadataForLambda(LocationRepository$authorizedCacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(LocationRepository$authorizedCacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForLambda(LocationRepository$getByIdStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForInterface(ILocationAccessor, 'ILocationAccessor', VOID, VOID, VOID, [1, 0]);
initMetadataForInterface(ILocationMutator, 'ILocationMutator', VOID, VOID, VOID, [2]);
initMetadataForClass(LocationRepository, 'LocationRepository', VOID, VOID, [ILocationAccessor, ILocationMutator], [1, 0, 2]);
initMetadataForInterface(IReferralAccessor, 'IReferralAccessor', VOID, VOID, VOID, [0]);
initMetadataForClass(ReferralRepository, 'ReferralRepository', VOID, VOID, [IReferralAccessor], [0]);
initMetadataForLambda(RoleRepository$authorizedCacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(RoleRepository$authorizedCacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForLambda(RoleRepository$getByIdStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($getRemoteApiDataCOROUTINE$7, CoroutineImpl);
initMetadataForInterface(IRoleAccessor, 'IRoleAccessor', VOID, VOID, VOID, [1, 2]);
initMetadataForInterface(IRoleMutator, 'IRoleMutator', VOID, VOID, VOID, [1, 2]);
initMetadataForClass(RoleRepository, 'RoleRepository', VOID, VOID, [IRoleAccessor, IRoleMutator], [1, 2, 0]);
initMetadataForObject(DayOfWeekSerializer, 'DayOfWeekSerializer', VOID, VOID, [KSerializer]);
initMetadataForCoroutine($getCompanySettingsCOROUTINE$9, CoroutineImpl);
initMetadataForInterface(ICompanyRemoteSource, 'ICompanyRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForClass(CompanyRemoteSource, 'CompanyRemoteSource', VOID, VOID, [ICompanyRemoteSource], [1]);
initMetadataForInterface(IDepartmentRemoteSource, 'IDepartmentRemoteSource', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForCompanion(Companion_5);
initMetadataForLambda(DepartmentRemoteSource$listAuthorized$slambda, CoroutineImpl, VOID, [0]);
initMetadataForLambda(DepartmentRemoteSource$listAll$slambda, CoroutineImpl, VOID, [0]);
initMetadataForCoroutine($basePathCOROUTINE$10, CoroutineImpl);
initMetadataForCoroutine($getByIdCOROUTINE$11, CoroutineImpl);
initMetadataForClass(DepartmentRemoteSource, 'DepartmentRemoteSource', VOID, VOID, [IDepartmentRemoteSource], [0, 1, 2]);
initMetadataForInterface(ILocationRemoteSource, 'ILocationRemoteSource', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForInterface(IReferralRemoteSource, 'IReferralRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForInterface(IRoleRemoteSource, 'IRoleRemoteSource', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForCompanion(Companion_6);
initMetadataForLambda(LocationRemoteSource$list$slambda, CoroutineImpl, VOID, [0]);
initMetadataForCoroutine($getByIdCOROUTINE$14, CoroutineImpl);
initMetadataForClass(LocationRemoteSource, 'LocationRemoteSource', VOID, VOID, [ILocationRemoteSource], [0, 1, 2]);
initMetadataForClass(ReferralRemoteSource, 'ReferralRemoteSource', VOID, VOID, [IReferralRemoteSource], [1]);
initMetadataForCompanion(Companion_7);
initMetadataForLambda(RoleRemoteSource$listAuthorizedRoles$slambda, CoroutineImpl, VOID, [0]);
initMetadataForLambda(RoleRemoteSource$listAllRoles$slambda, CoroutineImpl, VOID, [0]);
initMetadataForCoroutine($getByIdCOROUTINE$17, CoroutineImpl);
initMetadataForCoroutine($getBasePathCOROUTINE$20, CoroutineImpl);
initMetadataForClass(RoleRemoteSource, 'RoleRemoteSource', VOID, VOID, [IRoleRemoteSource], [0, 1, 2]);
initMetadataForClass(CompanySettings, 'CompanySettings');
initMetadataForClass(Department, 'Department');
initMetadataForClass(Location, 'Location');
initMetadataForClass(Role, 'Role');
initMetadataForClass(Station, 'Station');
//endregion
function toDomain(_this__u8e3s4) {
  return new CompanySettings(_this__u8e3s4.a78_1);
}
function toDomain_0(_this__u8e3s4) {
  return new Department(_this__u8e3s4.b78_1, _this__u8e3s4.c78_1, _this__u8e3s4.d78_1, _this__u8e3s4.e78_1);
}
function toDomain_1(_this__u8e3s4) {
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = _this__u8e3s4.j78_1;
  var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs_0 = _this__u8e3s4.k78_1;
  var tmp_0 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs_1 = _this__u8e3s4.l78_1;
  var tmp$ret$2 = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
  return new Location(_this__u8e3s4.f78_1, _this__u8e3s4.h78_1, _this__u8e3s4.i78_1, tmp, tmp_0, tmp$ret$2, _this__u8e3s4.m78_1, _this__u8e3s4.g78_1, _this__u8e3s4.n78_1, _this__u8e3s4.o78_1, _this__u8e3s4.p78_1, _this__u8e3s4.q78_1, _this__u8e3s4.r78_1, _this__u8e3s4.s78_1, _this__u8e3s4.t78_1, _this__u8e3s4.u78_1, _this__u8e3s4.v78_1, _this__u8e3s4.w78_1, _this__u8e3s4.x78_1, _this__u8e3s4.y78_1, _this__u8e3s4.z78_1, _this__u8e3s4.a79_1, orFalse(_this__u8e3s4.b79_1), orFalse(_this__u8e3s4.c79_1), orFalse(_this__u8e3s4.d79_1), orFalse(_this__u8e3s4.e79_1), orFalse(_this__u8e3s4.f79_1), orFalse(_this__u8e3s4.g79_1), orFalse(_this__u8e3s4.h79_1), _this__u8e3s4.i79_1, orFalse(_this__u8e3s4.j79_1));
}
function toDomain_2(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.p79_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = toDomain_3(item);
    destination.e(tmp$ret$0);
  }
  return new Role(_this__u8e3s4.k79_1, _this__u8e3s4.l79_1, _this__u8e3s4.m79_1, _this__u8e3s4.n79_1, _this__u8e3s4.o79_1, destination);
}
function toDomain_3(_this__u8e3s4) {
  return new Station(_this__u8e3s4.q79_1, _this__u8e3s4.r79_1, _this__u8e3s4.s79_1);
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiAuthorizedDepartment', this, 4);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('location_id', false);
  tmp0_serialDesc.wy('default', false);
  this.t79_1 = tmp0_serialDesc;
}
protoOf($serializer).u79 = function (encoder, value) {
  var tmp0_desc = this.t79_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.b78_1);
  tmp1_output.zs(tmp0_desc, 1, value.c78_1);
  tmp1_output.vs(tmp0_desc, 2, value.d78_1);
  tmp1_output.rs(tmp0_desc, 3, value.e78_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.u79(encoder, value instanceof ApiAuthorizedDepartment ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.t79_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = new Long(0, 0);
  var tmp7_local3 = false;
  var tmp8_input = decoder.kr(tmp0_desc);
  if (tmp8_input.as()) {
    tmp4_local0 = tmp8_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.qr(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.mr(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.qr(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.mr(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.lr(tmp0_desc);
  return ApiAuthorizedDepartment_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer).xn = function () {
  return this.t79_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiAuthorizedDepartment_init_$Init$(seen0, id, name, locationId, isDefault, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance().t79_1);
  }
  $this.b78_1 = id;
  $this.c78_1 = name;
  $this.d78_1 = locationId;
  $this.e78_1 = isDefault;
  return $this;
}
function ApiAuthorizedDepartment_init_$Create$(seen0, id, name, locationId, isDefault, serializationConstructorMarker) {
  return ApiAuthorizedDepartment_init_$Init$(seen0, id, name, locationId, isDefault, serializationConstructorMarker, objectCreate(protoOf(ApiAuthorizedDepartment)));
}
function ApiAuthorizedDepartment(id, name, locationId, isDefault) {
  this.b78_1 = id;
  this.c78_1 = name;
  this.d78_1 = locationId;
  this.e78_1 = isDefault;
}
protoOf(ApiAuthorizedDepartment).toString = function () {
  return 'ApiAuthorizedDepartment(id=' + this.b78_1.toString() + ', name=' + this.c78_1 + ', locationId=' + this.d78_1.toString() + ', isDefault=' + this.e78_1 + ')';
};
protoOf(ApiAuthorizedDepartment).hashCode = function () {
  var result = this.b78_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.c78_1) | 0;
  result = imul(result, 31) + this.d78_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.e78_1) | 0;
  return result;
};
protoOf(ApiAuthorizedDepartment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAuthorizedDepartment))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAuthorizedDepartment ? other : THROW_CCE();
  if (!this.b78_1.equals(tmp0_other_with_cast.b78_1))
    return false;
  if (!(this.c78_1 === tmp0_other_with_cast.c78_1))
    return false;
  if (!this.d78_1.equals(tmp0_other_with_cast.d78_1))
    return false;
  if (!(this.e78_1 === tmp0_other_with_cast.e78_1))
    return false;
  return true;
};
function Companion_0() {
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiAuthorizedRole', this, 1);
  tmp0_serialDesc.wy('id', false);
  this.v79_1 = tmp0_serialDesc;
}
protoOf($serializer_0).w79 = function (encoder, value) {
  var tmp0_desc = this.v79_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.x79_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.w79(encoder, value instanceof ApiAuthorizedRole ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.v79_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiAuthorizedRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).xn = function () {
  return this.v79_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ApiAuthorizedRole_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().v79_1);
  }
  $this.x79_1 = id;
  return $this;
}
function ApiAuthorizedRole_init_$Create$(seen0, id, serializationConstructorMarker) {
  return ApiAuthorizedRole_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(ApiAuthorizedRole)));
}
function ApiAuthorizedRole(id) {
  this.x79_1 = id;
}
protoOf(ApiAuthorizedRole).toString = function () {
  return 'ApiAuthorizedRole(id=' + this.x79_1.toString() + ')';
};
protoOf(ApiAuthorizedRole).hashCode = function () {
  return this.x79_1.hashCode();
};
protoOf(ApiAuthorizedRole).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAuthorizedRole))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAuthorizedRole ? other : THROW_CCE();
  if (!this.x79_1.equals(tmp0_other_with_cast.x79_1))
    return false;
  return true;
};
function Companion_1() {
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiCompanySettings', this, 1);
  tmp0_serialDesc.wy('start_week_on', false);
  this.y79_1 = tmp0_serialDesc;
}
protoOf($serializer_1).z79 = function (encoder, value) {
  var tmp0_desc = this.y79_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.dt(tmp0_desc, 0, DayOfWeekSerializer_getInstance(), value.a78_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.z79(encoder, value instanceof ApiCompanySettings ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.y79_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, DayOfWeekSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, DayOfWeekSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiCompanySettings_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).xn = function () {
  return this.y79_1;
};
protoOf($serializer_1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(DayOfWeekSerializer_getInstance())];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ApiCompanySettings_init_$Init$(seen0, startWeekOn, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().y79_1);
  }
  $this.a78_1 = startWeekOn;
  return $this;
}
function ApiCompanySettings_init_$Create$(seen0, startWeekOn, serializationConstructorMarker) {
  return ApiCompanySettings_init_$Init$(seen0, startWeekOn, serializationConstructorMarker, objectCreate(protoOf(ApiCompanySettings)));
}
function ApiCompanySettings(startWeekOn) {
  this.a78_1 = startWeekOn;
}
protoOf(ApiCompanySettings).toString = function () {
  return 'ApiCompanySettings(startWeekOn=' + toString(this.a78_1) + ')';
};
protoOf(ApiCompanySettings).hashCode = function () {
  return this.a78_1 == null ? 0 : this.a78_1.hashCode();
};
protoOf(ApiCompanySettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiCompanySettings))
    return false;
  var tmp0_other_with_cast = other instanceof ApiCompanySettings ? other : THROW_CCE();
  if (!equals(this.a78_1, tmp0_other_with_cast.a78_1))
    return false;
  return true;
};
function Companion_2() {
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiDepartment', this, 2);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('location_id', false);
  this.a7a_1 = tmp0_serialDesc;
}
protoOf($serializer_2).b7a = function (encoder, value) {
  var tmp0_desc = this.a7a_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.c7a_1);
  tmp1_output.vs(tmp0_desc, 1, value.d7a_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_2).yn = function (encoder, value) {
  return this.b7a(encoder, value instanceof ApiDepartment ? value : THROW_CCE());
};
protoOf($serializer_2).zn = function (decoder) {
  var tmp0_desc = this.a7a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = new Long(0, 0);
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.qr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.qr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ApiDepartment_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_2).xn = function () {
  return this.a7a_1;
};
protoOf($serializer_2).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), LongSerializer_getInstance()];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function ApiDepartment_init_$Init$(seen0, id, locationId, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_2().a7a_1);
  }
  $this.c7a_1 = id;
  $this.d7a_1 = locationId;
  return $this;
}
function ApiDepartment_init_$Create$(seen0, id, locationId, serializationConstructorMarker) {
  return ApiDepartment_init_$Init$(seen0, id, locationId, serializationConstructorMarker, objectCreate(protoOf(ApiDepartment)));
}
function ApiDepartment(id, locationId) {
  this.c7a_1 = id;
  this.d7a_1 = locationId;
}
protoOf(ApiDepartment).toString = function () {
  return 'ApiDepartment(id=' + this.c7a_1.toString() + ', locationId=' + this.d7a_1.toString() + ')';
};
protoOf(ApiDepartment).hashCode = function () {
  var result = this.c7a_1.hashCode();
  result = imul(result, 31) + this.d7a_1.hashCode() | 0;
  return result;
};
protoOf(ApiDepartment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiDepartment))
    return false;
  var tmp0_other_with_cast = other instanceof ApiDepartment ? other : THROW_CCE();
  if (!this.c7a_1.equals(tmp0_other_with_cast.c7a_1))
    return false;
  if (!this.d7a_1.equals(tmp0_other_with_cast.d7a_1))
    return false;
  return true;
};
function Companion_3() {
}
var Companion_instance_5;
function Companion_getInstance_6() {
  return Companion_instance_5;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiLocation', this, 31);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('hash', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('country', false);
  tmp0_serialDesc.wy('state', true);
  tmp0_serialDesc.wy('city', true);
  tmp0_serialDesc.wy('formatted_address', true);
  tmp0_serialDesc.wy('timezone', false);
  tmp0_serialDesc.wy('mon_hours_close', false);
  tmp0_serialDesc.wy('tue_hours_close', false);
  tmp0_serialDesc.wy('wed_hours_close', false);
  tmp0_serialDesc.wy('thu_hours_close', false);
  tmp0_serialDesc.wy('fri_hours_close', false);
  tmp0_serialDesc.wy('sat_hours_close', false);
  tmp0_serialDesc.wy('sun_hours_close', false);
  tmp0_serialDesc.wy('mon_hours_open', false);
  tmp0_serialDesc.wy('tue_hours_open', false);
  tmp0_serialDesc.wy('wed_hours_open', false);
  tmp0_serialDesc.wy('thu_hours_open', false);
  tmp0_serialDesc.wy('fri_hours_open', false);
  tmp0_serialDesc.wy('sat_hours_open', false);
  tmp0_serialDesc.wy('sun_hours_open', false);
  tmp0_serialDesc.wy('mon_is_closed', true);
  tmp0_serialDesc.wy('tue_is_closed', true);
  tmp0_serialDesc.wy('wed_is_closed', true);
  tmp0_serialDesc.wy('thu_is_closed', true);
  tmp0_serialDesc.wy('fri_is_closed', true);
  tmp0_serialDesc.wy('sat_is_closed', true);
  tmp0_serialDesc.wy('sun_is_closed', true);
  tmp0_serialDesc.wy('shift_feedback', false);
  tmp0_serialDesc.wy('department_based_budget', true);
  this.e7a_1 = tmp0_serialDesc;
}
protoOf($serializer_3).f7a = function (encoder, value) {
  var tmp0_desc = this.e7a_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.f78_1);
  tmp1_output.zs(tmp0_desc, 1, value.g78_1);
  tmp1_output.zs(tmp0_desc, 2, value.h78_1);
  tmp1_output.zs(tmp0_desc, 3, value.i78_1);
  if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.j78_1 == null)) {
    tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.j78_1);
  }
  if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.k78_1 == null)) {
    tmp1_output.dt(tmp0_desc, 5, StringSerializer_getInstance(), value.k78_1);
  }
  if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.l78_1 == null)) {
    tmp1_output.dt(tmp0_desc, 6, StringSerializer_getInstance(), value.l78_1);
  }
  tmp1_output.zs(tmp0_desc, 7, value.m78_1);
  tmp1_output.zs(tmp0_desc, 8, value.n78_1);
  tmp1_output.zs(tmp0_desc, 9, value.o78_1);
  tmp1_output.zs(tmp0_desc, 10, value.p78_1);
  tmp1_output.zs(tmp0_desc, 11, value.q78_1);
  tmp1_output.zs(tmp0_desc, 12, value.r78_1);
  tmp1_output.zs(tmp0_desc, 13, value.s78_1);
  tmp1_output.zs(tmp0_desc, 14, value.t78_1);
  tmp1_output.zs(tmp0_desc, 15, value.u78_1);
  tmp1_output.zs(tmp0_desc, 16, value.v78_1);
  tmp1_output.zs(tmp0_desc, 17, value.w78_1);
  tmp1_output.zs(tmp0_desc, 18, value.x78_1);
  tmp1_output.zs(tmp0_desc, 19, value.y78_1);
  tmp1_output.zs(tmp0_desc, 20, value.z78_1);
  tmp1_output.zs(tmp0_desc, 21, value.a79_1);
  if (tmp1_output.ht(tmp0_desc, 22) ? true : !(value.b79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 22, BooleanSerializer_getInstance(), value.b79_1);
  }
  if (tmp1_output.ht(tmp0_desc, 23) ? true : !(value.c79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 23, BooleanSerializer_getInstance(), value.c79_1);
  }
  if (tmp1_output.ht(tmp0_desc, 24) ? true : !(value.d79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 24, BooleanSerializer_getInstance(), value.d79_1);
  }
  if (tmp1_output.ht(tmp0_desc, 25) ? true : !(value.e79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 25, BooleanSerializer_getInstance(), value.e79_1);
  }
  if (tmp1_output.ht(tmp0_desc, 26) ? true : !(value.f79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 26, BooleanSerializer_getInstance(), value.f79_1);
  }
  if (tmp1_output.ht(tmp0_desc, 27) ? true : !(value.g79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 27, BooleanSerializer_getInstance(), value.g79_1);
  }
  if (tmp1_output.ht(tmp0_desc, 28) ? true : !(value.h79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 28, BooleanSerializer_getInstance(), value.h79_1);
  }
  tmp1_output.rs(tmp0_desc, 29, value.i79_1);
  if (tmp1_output.ht(tmp0_desc, 30) ? true : !(value.j79_1 == null)) {
    tmp1_output.dt(tmp0_desc, 30, BooleanSerializer_getInstance(), value.j79_1);
  }
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_3).yn = function (encoder, value) {
  return this.f7a(encoder, value instanceof ApiLocation ? value : THROW_CCE());
};
protoOf($serializer_3).zn = function (decoder) {
  var tmp0_desc = this.e7a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_local12 = null;
  var tmp17_local13 = null;
  var tmp18_local14 = null;
  var tmp19_local15 = null;
  var tmp20_local16 = null;
  var tmp21_local17 = null;
  var tmp22_local18 = null;
  var tmp23_local19 = null;
  var tmp24_local20 = null;
  var tmp25_local21 = null;
  var tmp26_local22 = null;
  var tmp27_local23 = null;
  var tmp28_local24 = null;
  var tmp29_local25 = null;
  var tmp30_local26 = null;
  var tmp31_local27 = null;
  var tmp32_local28 = null;
  var tmp33_local29 = false;
  var tmp34_local30 = null;
  var tmp35_input = decoder.kr(tmp0_desc);
  if (tmp35_input.as()) {
    tmp4_local0 = tmp35_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp35_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp35_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp35_input.ur(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp35_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp35_input.yr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp35_input.yr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp35_input.ur(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp35_input.ur(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp35_input.ur(tmp0_desc, 9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp35_input.ur(tmp0_desc, 10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp35_input.ur(tmp0_desc, 11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp35_input.ur(tmp0_desc, 12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp35_input.ur(tmp0_desc, 13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp35_input.ur(tmp0_desc, 14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp35_input.ur(tmp0_desc, 15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp35_input.ur(tmp0_desc, 16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp21_local17 = tmp35_input.ur(tmp0_desc, 17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    tmp22_local18 = tmp35_input.ur(tmp0_desc, 18);
    tmp3_bitMask0 = tmp3_bitMask0 | 262144;
    tmp23_local19 = tmp35_input.ur(tmp0_desc, 19);
    tmp3_bitMask0 = tmp3_bitMask0 | 524288;
    tmp24_local20 = tmp35_input.ur(tmp0_desc, 20);
    tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    tmp25_local21 = tmp35_input.ur(tmp0_desc, 21);
    tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    tmp26_local22 = tmp35_input.yr(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp26_local22);
    tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    tmp27_local23 = tmp35_input.yr(tmp0_desc, 23, BooleanSerializer_getInstance(), tmp27_local23);
    tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    tmp28_local24 = tmp35_input.yr(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp28_local24);
    tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
    tmp29_local25 = tmp35_input.yr(tmp0_desc, 25, BooleanSerializer_getInstance(), tmp29_local25);
    tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
    tmp30_local26 = tmp35_input.yr(tmp0_desc, 26, BooleanSerializer_getInstance(), tmp30_local26);
    tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    tmp31_local27 = tmp35_input.yr(tmp0_desc, 27, BooleanSerializer_getInstance(), tmp31_local27);
    tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
    tmp32_local28 = tmp35_input.yr(tmp0_desc, 28, BooleanSerializer_getInstance(), tmp32_local28);
    tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
    tmp33_local29 = tmp35_input.mr(tmp0_desc, 29);
    tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
    tmp34_local30 = tmp35_input.yr(tmp0_desc, 30, BooleanSerializer_getInstance(), tmp34_local30);
    tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp35_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp35_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp35_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp35_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp35_input.ur(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp35_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp35_input.yr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp35_input.yr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp35_input.ur(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp35_input.ur(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp35_input.ur(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp35_input.ur(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp35_input.ur(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp35_input.ur(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp35_input.ur(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp35_input.ur(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp35_input.ur(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp35_input.ur(tmp0_desc, 16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp21_local17 = tmp35_input.ur(tmp0_desc, 17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        case 18:
          tmp22_local18 = tmp35_input.ur(tmp0_desc, 18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          break;
        case 19:
          tmp23_local19 = tmp35_input.ur(tmp0_desc, 19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          break;
        case 20:
          tmp24_local20 = tmp35_input.ur(tmp0_desc, 20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          break;
        case 21:
          tmp25_local21 = tmp35_input.ur(tmp0_desc, 21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          break;
        case 22:
          tmp26_local22 = tmp35_input.yr(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp26_local22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          break;
        case 23:
          tmp27_local23 = tmp35_input.yr(tmp0_desc, 23, BooleanSerializer_getInstance(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          break;
        case 24:
          tmp28_local24 = tmp35_input.yr(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          break;
        case 25:
          tmp29_local25 = tmp35_input.yr(tmp0_desc, 25, BooleanSerializer_getInstance(), tmp29_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          break;
        case 26:
          tmp30_local26 = tmp35_input.yr(tmp0_desc, 26, BooleanSerializer_getInstance(), tmp30_local26);
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          break;
        case 27:
          tmp31_local27 = tmp35_input.yr(tmp0_desc, 27, BooleanSerializer_getInstance(), tmp31_local27);
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
          break;
        case 28:
          tmp32_local28 = tmp35_input.yr(tmp0_desc, 28, BooleanSerializer_getInstance(), tmp32_local28);
          tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
          break;
        case 29:
          tmp33_local29 = tmp35_input.mr(tmp0_desc, 29);
          tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
          break;
        case 30:
          tmp34_local30 = tmp35_input.yr(tmp0_desc, 30, BooleanSerializer_getInstance(), tmp34_local30);
          tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp35_input.lr(tmp0_desc);
  return ApiLocation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, tmp32_local28, tmp33_local29, tmp34_local30, null);
};
protoOf($serializer_3).xn = function () {
  return this.e7a_1;
};
protoOf($serializer_3).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance())];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function ApiLocation_init_$Init$(seen0, id, hash, name, country, state, city, formattedAddress, timeZone, monHoursClose, tueHoursClose, wedHoursClose, thuHoursClose, friHoursClose, satHoursClose, sunHoursClose, monHoursOpen, tueHoursOpen, wedHoursOpen, thuHoursOpen, friHoursOpen, satHoursOpen, sunHoursOpen, monIsClosed, tueIsClosed, wedIsClosed, thuIsClosed, friIsClosed, satIsClosed, sunIsClosed, shiftFeedback, departmentBasedBudget, serializationConstructorMarker, $this) {
  if (!(541065103 === (541065103 & seen0))) {
    throwMissingFieldException(seen0, 541065103, $serializer_getInstance_3().e7a_1);
  }
  $this.f78_1 = id;
  $this.g78_1 = hash;
  $this.h78_1 = name;
  $this.i78_1 = country;
  if (0 === (seen0 & 16))
    $this.j78_1 = null;
  else
    $this.j78_1 = state;
  if (0 === (seen0 & 32))
    $this.k78_1 = null;
  else
    $this.k78_1 = city;
  if (0 === (seen0 & 64))
    $this.l78_1 = null;
  else
    $this.l78_1 = formattedAddress;
  $this.m78_1 = timeZone;
  $this.n78_1 = monHoursClose;
  $this.o78_1 = tueHoursClose;
  $this.p78_1 = wedHoursClose;
  $this.q78_1 = thuHoursClose;
  $this.r78_1 = friHoursClose;
  $this.s78_1 = satHoursClose;
  $this.t78_1 = sunHoursClose;
  $this.u78_1 = monHoursOpen;
  $this.v78_1 = tueHoursOpen;
  $this.w78_1 = wedHoursOpen;
  $this.x78_1 = thuHoursOpen;
  $this.y78_1 = friHoursOpen;
  $this.z78_1 = satHoursOpen;
  $this.a79_1 = sunHoursOpen;
  if (0 === (seen0 & 4194304))
    $this.b79_1 = null;
  else
    $this.b79_1 = monIsClosed;
  if (0 === (seen0 & 8388608))
    $this.c79_1 = null;
  else
    $this.c79_1 = tueIsClosed;
  if (0 === (seen0 & 16777216))
    $this.d79_1 = null;
  else
    $this.d79_1 = wedIsClosed;
  if (0 === (seen0 & 33554432))
    $this.e79_1 = null;
  else
    $this.e79_1 = thuIsClosed;
  if (0 === (seen0 & 67108864))
    $this.f79_1 = null;
  else
    $this.f79_1 = friIsClosed;
  if (0 === (seen0 & 134217728))
    $this.g79_1 = null;
  else
    $this.g79_1 = satIsClosed;
  if (0 === (seen0 & 268435456))
    $this.h79_1 = null;
  else
    $this.h79_1 = sunIsClosed;
  $this.i79_1 = shiftFeedback;
  if (0 === (seen0 & 1073741824))
    $this.j79_1 = null;
  else
    $this.j79_1 = departmentBasedBudget;
  return $this;
}
function ApiLocation_init_$Create$(seen0, id, hash, name, country, state, city, formattedAddress, timeZone, monHoursClose, tueHoursClose, wedHoursClose, thuHoursClose, friHoursClose, satHoursClose, sunHoursClose, monHoursOpen, tueHoursOpen, wedHoursOpen, thuHoursOpen, friHoursOpen, satHoursOpen, sunHoursOpen, monIsClosed, tueIsClosed, wedIsClosed, thuIsClosed, friIsClosed, satIsClosed, sunIsClosed, shiftFeedback, departmentBasedBudget, serializationConstructorMarker) {
  return ApiLocation_init_$Init$(seen0, id, hash, name, country, state, city, formattedAddress, timeZone, monHoursClose, tueHoursClose, wedHoursClose, thuHoursClose, friHoursClose, satHoursClose, sunHoursClose, monHoursOpen, tueHoursOpen, wedHoursOpen, thuHoursOpen, friHoursOpen, satHoursOpen, sunHoursOpen, monIsClosed, tueIsClosed, wedIsClosed, thuIsClosed, friIsClosed, satIsClosed, sunIsClosed, shiftFeedback, departmentBasedBudget, serializationConstructorMarker, objectCreate(protoOf(ApiLocation)));
}
function ApiLocation(id, hash, name, country, state, city, formattedAddress, timeZone, monHoursClose, tueHoursClose, wedHoursClose, thuHoursClose, friHoursClose, satHoursClose, sunHoursClose, monHoursOpen, tueHoursOpen, wedHoursOpen, thuHoursOpen, friHoursOpen, satHoursOpen, sunHoursOpen, monIsClosed, tueIsClosed, wedIsClosed, thuIsClosed, friIsClosed, satIsClosed, sunIsClosed, shiftFeedback, departmentBasedBudget) {
  state = state === VOID ? null : state;
  city = city === VOID ? null : city;
  formattedAddress = formattedAddress === VOID ? null : formattedAddress;
  monIsClosed = monIsClosed === VOID ? null : monIsClosed;
  tueIsClosed = tueIsClosed === VOID ? null : tueIsClosed;
  wedIsClosed = wedIsClosed === VOID ? null : wedIsClosed;
  thuIsClosed = thuIsClosed === VOID ? null : thuIsClosed;
  friIsClosed = friIsClosed === VOID ? null : friIsClosed;
  satIsClosed = satIsClosed === VOID ? null : satIsClosed;
  sunIsClosed = sunIsClosed === VOID ? null : sunIsClosed;
  departmentBasedBudget = departmentBasedBudget === VOID ? null : departmentBasedBudget;
  this.f78_1 = id;
  this.g78_1 = hash;
  this.h78_1 = name;
  this.i78_1 = country;
  this.j78_1 = state;
  this.k78_1 = city;
  this.l78_1 = formattedAddress;
  this.m78_1 = timeZone;
  this.n78_1 = monHoursClose;
  this.o78_1 = tueHoursClose;
  this.p78_1 = wedHoursClose;
  this.q78_1 = thuHoursClose;
  this.r78_1 = friHoursClose;
  this.s78_1 = satHoursClose;
  this.t78_1 = sunHoursClose;
  this.u78_1 = monHoursOpen;
  this.v78_1 = tueHoursOpen;
  this.w78_1 = wedHoursOpen;
  this.x78_1 = thuHoursOpen;
  this.y78_1 = friHoursOpen;
  this.z78_1 = satHoursOpen;
  this.a79_1 = sunHoursOpen;
  this.b79_1 = monIsClosed;
  this.c79_1 = tueIsClosed;
  this.d79_1 = wedIsClosed;
  this.e79_1 = thuIsClosed;
  this.f79_1 = friIsClosed;
  this.g79_1 = satIsClosed;
  this.h79_1 = sunIsClosed;
  this.i79_1 = shiftFeedback;
  this.j79_1 = departmentBasedBudget;
}
protoOf(ApiLocation).toString = function () {
  return 'ApiLocation(id=' + this.f78_1.toString() + ', hash=' + this.g78_1 + ', name=' + this.h78_1 + ', country=' + this.i78_1 + ', state=' + this.j78_1 + ', city=' + this.k78_1 + ', formattedAddress=' + this.l78_1 + ', timeZone=' + this.m78_1 + ', monHoursClose=' + this.n78_1 + ', tueHoursClose=' + this.o78_1 + ', wedHoursClose=' + this.p78_1 + ', thuHoursClose=' + this.q78_1 + ', friHoursClose=' + this.r78_1 + ', satHoursClose=' + this.s78_1 + ', sunHoursClose=' + this.t78_1 + ', monHoursOpen=' + this.u78_1 + ', tueHoursOpen=' + this.v78_1 + ', wedHoursOpen=' + this.w78_1 + ', thuHoursOpen=' + this.x78_1 + ', friHoursOpen=' + this.y78_1 + ', satHoursOpen=' + this.z78_1 + ', sunHoursOpen=' + this.a79_1 + ', monIsClosed=' + this.b79_1 + ', tueIsClosed=' + this.c79_1 + ', wedIsClosed=' + this.d79_1 + ', thuIsClosed=' + this.e79_1 + ', friIsClosed=' + this.f79_1 + ', satIsClosed=' + this.g79_1 + ', sunIsClosed=' + this.h79_1 + ', shiftFeedback=' + this.i79_1 + ', departmentBasedBudget=' + this.j79_1 + ')';
};
protoOf(ApiLocation).hashCode = function () {
  var result = this.f78_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.g78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.h78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.i78_1) | 0;
  result = imul(result, 31) + (this.j78_1 == null ? 0 : getStringHashCode(this.j78_1)) | 0;
  result = imul(result, 31) + (this.k78_1 == null ? 0 : getStringHashCode(this.k78_1)) | 0;
  result = imul(result, 31) + (this.l78_1 == null ? 0 : getStringHashCode(this.l78_1)) | 0;
  result = imul(result, 31) + getStringHashCode(this.m78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.n78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.o78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.p78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.q78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.r78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.s78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.t78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.u78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.v78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.w78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.x78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.y78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.z78_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.a79_1) | 0;
  result = imul(result, 31) + (this.b79_1 == null ? 0 : getBooleanHashCode(this.b79_1)) | 0;
  result = imul(result, 31) + (this.c79_1 == null ? 0 : getBooleanHashCode(this.c79_1)) | 0;
  result = imul(result, 31) + (this.d79_1 == null ? 0 : getBooleanHashCode(this.d79_1)) | 0;
  result = imul(result, 31) + (this.e79_1 == null ? 0 : getBooleanHashCode(this.e79_1)) | 0;
  result = imul(result, 31) + (this.f79_1 == null ? 0 : getBooleanHashCode(this.f79_1)) | 0;
  result = imul(result, 31) + (this.g79_1 == null ? 0 : getBooleanHashCode(this.g79_1)) | 0;
  result = imul(result, 31) + (this.h79_1 == null ? 0 : getBooleanHashCode(this.h79_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i79_1) | 0;
  result = imul(result, 31) + (this.j79_1 == null ? 0 : getBooleanHashCode(this.j79_1)) | 0;
  return result;
};
protoOf(ApiLocation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiLocation))
    return false;
  var tmp0_other_with_cast = other instanceof ApiLocation ? other : THROW_CCE();
  if (!this.f78_1.equals(tmp0_other_with_cast.f78_1))
    return false;
  if (!(this.g78_1 === tmp0_other_with_cast.g78_1))
    return false;
  if (!(this.h78_1 === tmp0_other_with_cast.h78_1))
    return false;
  if (!(this.i78_1 === tmp0_other_with_cast.i78_1))
    return false;
  if (!(this.j78_1 == tmp0_other_with_cast.j78_1))
    return false;
  if (!(this.k78_1 == tmp0_other_with_cast.k78_1))
    return false;
  if (!(this.l78_1 == tmp0_other_with_cast.l78_1))
    return false;
  if (!(this.m78_1 === tmp0_other_with_cast.m78_1))
    return false;
  if (!(this.n78_1 === tmp0_other_with_cast.n78_1))
    return false;
  if (!(this.o78_1 === tmp0_other_with_cast.o78_1))
    return false;
  if (!(this.p78_1 === tmp0_other_with_cast.p78_1))
    return false;
  if (!(this.q78_1 === tmp0_other_with_cast.q78_1))
    return false;
  if (!(this.r78_1 === tmp0_other_with_cast.r78_1))
    return false;
  if (!(this.s78_1 === tmp0_other_with_cast.s78_1))
    return false;
  if (!(this.t78_1 === tmp0_other_with_cast.t78_1))
    return false;
  if (!(this.u78_1 === tmp0_other_with_cast.u78_1))
    return false;
  if (!(this.v78_1 === tmp0_other_with_cast.v78_1))
    return false;
  if (!(this.w78_1 === tmp0_other_with_cast.w78_1))
    return false;
  if (!(this.x78_1 === tmp0_other_with_cast.x78_1))
    return false;
  if (!(this.y78_1 === tmp0_other_with_cast.y78_1))
    return false;
  if (!(this.z78_1 === tmp0_other_with_cast.z78_1))
    return false;
  if (!(this.a79_1 === tmp0_other_with_cast.a79_1))
    return false;
  if (!(this.b79_1 == tmp0_other_with_cast.b79_1))
    return false;
  if (!(this.c79_1 == tmp0_other_with_cast.c79_1))
    return false;
  if (!(this.d79_1 == tmp0_other_with_cast.d79_1))
    return false;
  if (!(this.e79_1 == tmp0_other_with_cast.e79_1))
    return false;
  if (!(this.f79_1 == tmp0_other_with_cast.f79_1))
    return false;
  if (!(this.g79_1 == tmp0_other_with_cast.g79_1))
    return false;
  if (!(this.h79_1 == tmp0_other_with_cast.h79_1))
    return false;
  if (!(this.i79_1 === tmp0_other_with_cast.i79_1))
    return false;
  if (!(this.j79_1 == tmp0_other_with_cast.j79_1))
    return false;
  return true;
};
function ApiRole$Companion$$childSerializers$_anonymous__yzulae() {
  return new ArrayListSerializer($serializer_getInstance_5());
}
function Companion_4() {
  Companion_instance_6 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g7a_1 = [null, null, null, null, null, lazy(tmp_0, ApiRole$Companion$$childSerializers$_anonymous__yzulae)];
}
var Companion_instance_6;
function Companion_getInstance_7() {
  if (Companion_instance_6 == null)
    new Companion_4();
  return Companion_instance_6;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiRole', this, 6);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('location_id', false);
  tmp0_serialDesc.wy('department_id', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('color', false);
  tmp0_serialDesc.wy('stations', false);
  this.h7a_1 = tmp0_serialDesc;
}
protoOf($serializer_4).i7a = function (encoder, value) {
  var tmp0_desc = this.h7a_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_7().g7a_1;
  tmp1_output.vs(tmp0_desc, 0, value.k79_1);
  tmp1_output.vs(tmp0_desc, 1, value.l79_1);
  tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.m79_1);
  tmp1_output.zs(tmp0_desc, 3, value.n79_1);
  tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.o79_1);
  tmp1_output.bt(tmp0_desc, 5, tmp2_cached[5].t(), value.p79_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_4).yn = function (encoder, value) {
  return this.i7a(encoder, value instanceof ApiRole ? value : THROW_CCE());
};
protoOf($serializer_4).zn = function (decoder) {
  var tmp0_desc = this.h7a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = new Long(0, 0);
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_input = decoder.kr(tmp0_desc);
  var tmp11_cached = Companion_getInstance_7().g7a_1;
  if (tmp10_input.as()) {
    tmp4_local0 = tmp10_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.qr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.yr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.ur(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.wr(tmp0_desc, 5, tmp11_cached[5].t(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.qr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.yr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.ur(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.wr(tmp0_desc, 5, tmp11_cached[5].t(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.lr(tmp0_desc);
  return ApiRole_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_4).xn = function () {
  return this.h7a_1;
};
protoOf($serializer_4).pz = function () {
  var tmp0_cached = Companion_getInstance_7().g7a_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[5].t()];
};
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function ApiRole_init_$Init$(seen0, id, locationId, departmentId, name, color, stations, serializationConstructorMarker, $this) {
  if (!(63 === (63 & seen0))) {
    throwMissingFieldException(seen0, 63, $serializer_getInstance_4().h7a_1);
  }
  $this.k79_1 = id;
  $this.l79_1 = locationId;
  $this.m79_1 = departmentId;
  $this.n79_1 = name;
  $this.o79_1 = color;
  $this.p79_1 = stations;
  return $this;
}
function ApiRole_init_$Create$(seen0, id, locationId, departmentId, name, color, stations, serializationConstructorMarker) {
  return ApiRole_init_$Init$(seen0, id, locationId, departmentId, name, color, stations, serializationConstructorMarker, objectCreate(protoOf(ApiRole)));
}
function ApiRole(id, locationId, departmentId, name, color, stations) {
  Companion_getInstance_7();
  this.k79_1 = id;
  this.l79_1 = locationId;
  this.m79_1 = departmentId;
  this.n79_1 = name;
  this.o79_1 = color;
  this.p79_1 = stations;
}
protoOf(ApiRole).toString = function () {
  return 'ApiRole(id=' + this.k79_1.toString() + ', locationId=' + this.l79_1.toString() + ', departmentId=' + toString(this.m79_1) + ', name=' + this.n79_1 + ', color=' + this.o79_1 + ', stations=' + toString_0(this.p79_1) + ')';
};
protoOf(ApiRole).hashCode = function () {
  var result = this.k79_1.hashCode();
  result = imul(result, 31) + this.l79_1.hashCode() | 0;
  result = imul(result, 31) + (this.m79_1 == null ? 0 : this.m79_1.hashCode()) | 0;
  result = imul(result, 31) + getStringHashCode(this.n79_1) | 0;
  result = imul(result, 31) + (this.o79_1 == null ? 0 : getStringHashCode(this.o79_1)) | 0;
  result = imul(result, 31) + hashCode(this.p79_1) | 0;
  return result;
};
protoOf(ApiRole).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiRole))
    return false;
  var tmp0_other_with_cast = other instanceof ApiRole ? other : THROW_CCE();
  if (!this.k79_1.equals(tmp0_other_with_cast.k79_1))
    return false;
  if (!this.l79_1.equals(tmp0_other_with_cast.l79_1))
    return false;
  if (!equals(this.m79_1, tmp0_other_with_cast.m79_1))
    return false;
  if (!(this.n79_1 === tmp0_other_with_cast.n79_1))
    return false;
  if (!(this.o79_1 == tmp0_other_with_cast.o79_1))
    return false;
  if (!equals(this.p79_1, tmp0_other_with_cast.p79_1))
    return false;
  return true;
};
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.core.data.models.ApiStation', this, 3);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('station_number', false);
  tmp0_serialDesc.wy('name', false);
  this.j7a_1 = tmp0_serialDesc;
}
protoOf($serializer_5).k7a = function (encoder, value) {
  var tmp0_desc = this.j7a_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.q79_1);
  tmp1_output.us(tmp0_desc, 1, value.r79_1);
  tmp1_output.zs(tmp0_desc, 2, value.s79_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_5).yn = function (encoder, value) {
  return this.k7a(encoder, value instanceof ApiStation ? value : THROW_CCE());
};
protoOf($serializer_5).zn = function (decoder) {
  var tmp0_desc = this.j7a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = 0;
  var tmp6_local2 = null;
  var tmp7_input = decoder.kr(tmp0_desc);
  if (tmp7_input.as()) {
    tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.lr(tmp0_desc);
  return ApiStation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_5).xn = function () {
  return this.j7a_1;
};
protoOf($serializer_5).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function ApiStation_init_$Init$(seen0, id, stationNumber, name, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_5().j7a_1);
  }
  $this.q79_1 = id;
  $this.r79_1 = stationNumber;
  $this.s79_1 = name;
  return $this;
}
function ApiStation_init_$Create$(seen0, id, stationNumber, name, serializationConstructorMarker) {
  return ApiStation_init_$Init$(seen0, id, stationNumber, name, serializationConstructorMarker, objectCreate(protoOf(ApiStation)));
}
function ApiStation() {
}
protoOf(ApiStation).toString = function () {
  return 'ApiStation(id=' + this.q79_1.toString() + ', stationNumber=' + this.r79_1 + ', name=' + this.s79_1 + ')';
};
protoOf(ApiStation).hashCode = function () {
  var result = this.q79_1.hashCode();
  result = imul(result, 31) + this.r79_1 | 0;
  result = imul(result, 31) + getStringHashCode(this.s79_1) | 0;
  return result;
};
protoOf(ApiStation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiStation))
    return false;
  var tmp0_other_with_cast = other instanceof ApiStation ? other : THROW_CCE();
  if (!this.q79_1.equals(tmp0_other_with_cast.q79_1))
    return false;
  if (!(this.r79_1 === tmp0_other_with_cast.r79_1))
    return false;
  if (!(this.s79_1 === tmp0_other_with_cast.s79_1))
    return false;
  return true;
};
function ILocalSource$put$ref($boundThis) {
  this.l7a_1 = $boundThis;
}
protoOf(ILocalSource$put$ref).m7a = function (p0, $completion) {
  return this.l7a_1.m2u(p0, $completion);
};
protoOf(ILocalSource$put$ref).h9 = function (p1, $completion) {
  return this.m7a(p1 instanceof CompanySettings ? p1 : THROW_CCE(), $completion);
};
function ILocalSource$put$ref_0($boundThis) {
  var i = new ILocalSource$put$ref($boundThis);
  var l = function (p0, $completion) {
    return i.m7a(p0, $completion);
  };
  l.callableName = 'put';
  l.$arity = 1;
  return l;
}
function CompanyRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.v7a_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(CompanyRepository$cacheStrategy$slambda).y7a = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(CompanyRepository$cacheStrategy$slambda).ma = function ($completion) {
  return this.y7a($completion);
};
protoOf(CompanyRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.w7a_1 = this.v7a_1.a7b_1;
          this.n8_1 = 1;
          suspendResult = this.v7a_1.z7a_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.x7a_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.w7a_1.d7b(this.x7a_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          return suspendResult;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(CompanyRepository$cacheStrategy$slambda).m32 = function (completion) {
  return new CompanyRepository$cacheStrategy$slambda(this.v7a_1, completion);
};
function CompanyRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new CompanyRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.y7a($completion);
  };
  l.$arity = 0;
  return l;
}
function CompanyRepository$cacheStrategy$lambda(it) {
  return it;
}
function CompanyRepository(sessionDataProvider, remoteSource, companySettingsLocalSource) {
  this.z7a_1 = sessionDataProvider;
  this.a7b_1 = remoteSource;
  this.b7b_1 = companySettingsLocalSource;
  var tmp = this;
  var tmp_0 = this.b7b_1.n18();
  var tmp_1 = ILocalSource$put$ref_0(this.b7b_1);
  var tmp_2 = CompanyRepository$cacheStrategy$slambda_0(this, null);
  tmp.c7b_1 = new SimpleValueEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, CompanyRepository$cacheStrategy$lambda);
}
function DepartmentRepository$authorizedCacheStrategy$slambda(this$0, resultContinuation) {
  this.m7b_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda).o7b = function (it, $completion) {
  var tmp = this.p7b(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.o7b((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.m7b_1.q7b_1.m2u(this.n7b_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda).p7b = function (it, completion) {
  var i = new DepartmentRepository$authorizedCacheStrategy$slambda(this.m7b_1, completion);
  i.n7b_1 = it;
  return i;
};
function DepartmentRepository$authorizedCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new DepartmentRepository$authorizedCacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.o7b(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function DepartmentRepository$authorizedCacheStrategy$slambda_1(this$0, resultContinuation) {
  this.f7c_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda_1).g7c = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda_1).ma = function ($completion) {
  return this.g7c($completion);
};
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.f7c_1.t7b_1.h7c(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DepartmentRepository$authorizedCacheStrategy$slambda_1).m32 = function (completion) {
  return new DepartmentRepository$authorizedCacheStrategy$slambda_1(this.f7c_1, completion);
};
function DepartmentRepository$authorizedCacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new DepartmentRepository$authorizedCacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.g7c($completion);
  };
  l.$arity = 0;
  return l;
}
function DepartmentRepository$authorizedCacheStrategy$lambda(it) {
  return toDomain_0(it);
}
function DepartmentRepository$authorizedCacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.i7c_1;
}
function DepartmentRepository$allCacheStrategy$slambda(this$0, resultContinuation) {
  this.u7c_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRepository$allCacheStrategy$slambda).w7c = function (it, $completion) {
  var tmp = this.x7c(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(DepartmentRepository$allCacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.w7c((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DepartmentRepository$allCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.u7c_1.r7b_1.m2u(this.v7c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DepartmentRepository$allCacheStrategy$slambda).x7c = function (it, completion) {
  var i = new DepartmentRepository$allCacheStrategy$slambda(this.u7c_1, completion);
  i.v7c_1 = it;
  return i;
};
function DepartmentRepository$allCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new DepartmentRepository$allCacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.w7c(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function DepartmentRepository$allCacheStrategy$slambda_1(this$0, resultContinuation) {
  this.g7d_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRepository$allCacheStrategy$slambda_1).h7d = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(DepartmentRepository$allCacheStrategy$slambda_1).ma = function ($completion) {
  return this.h7d($completion);
};
protoOf(DepartmentRepository$allCacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.g7d_1.t7b_1.i7d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DepartmentRepository$allCacheStrategy$slambda_1).m32 = function (completion) {
  return new DepartmentRepository$allCacheStrategy$slambda_1(this.g7d_1, completion);
};
function DepartmentRepository$allCacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new DepartmentRepository$allCacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.h7d($completion);
  };
  l.$arity = 0;
  return l;
}
function DepartmentRepository$allCacheStrategy$lambda(it) {
  return it;
}
function DepartmentRepository$allCacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.c7a_1;
}
function DepartmentRepository$getByIdStrategy$slambda(this$0, resultContinuation) {
  this.r7d_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRepository$getByIdStrategy$slambda).t7d = function (id, $completion) {
  var tmp = this.u7d(id, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(DepartmentRepository$getByIdStrategy$slambda).h9 = function (p1, $completion) {
  return this.t7d(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(DepartmentRepository$getByIdStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.r7d_1.t7b_1.v7d(this.s7d_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DepartmentRepository$getByIdStrategy$slambda).u7d = function (id, completion) {
  var i = new DepartmentRepository$getByIdStrategy$slambda(this.r7d_1, completion);
  i.s7d_1 = id;
  return i;
};
function DepartmentRepository$getByIdStrategy$slambda_0(this$0, resultContinuation) {
  var i = new DepartmentRepository$getByIdStrategy$slambda(this$0, resultContinuation);
  var l = function (id, $completion) {
    return i.t7d(id, $completion);
  };
  l.$arity = 1;
  return l;
}
function DepartmentRepository$getByIdStrategy$lambda(it) {
  return toDomain_0(it);
}
function DepartmentRepository$getByIdStrategy$lambda_0($this$SimpleGetEndpointCacheStrategy) {
  return $this$SimpleGetEndpointCacheStrategy.i7c_1;
}
function DepartmentRepository(authorizedLocalSource, allLocalSource, getByIdLocalSource, remoteSource) {
  this.q7b_1 = authorizedLocalSource;
  this.r7b_1 = allLocalSource;
  this.s7b_1 = getByIdLocalSource;
  this.t7b_1 = remoteSource;
  var tmp = this;
  var tmp_0 = this.q7b_1.n18();
  var tmp_1 = DepartmentRepository$authorizedCacheStrategy$slambda_0(this, null);
  var tmp_2 = DepartmentRepository$authorizedCacheStrategy$slambda_2(this, null);
  var tmp_3 = DepartmentRepository$authorizedCacheStrategy$lambda;
  tmp.u7b_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, DepartmentRepository$authorizedCacheStrategy$lambda_0);
  var tmp_4 = this;
  var tmp_5 = this.r7b_1.n18();
  var tmp_6 = DepartmentRepository$allCacheStrategy$slambda_0(this, null);
  var tmp_7 = DepartmentRepository$allCacheStrategy$slambda_2(this, null);
  var tmp_8 = DepartmentRepository$allCacheStrategy$lambda;
  tmp_4.v7b_1 = new SimpleListEndpointCacheStrategy(tmp_5, tmp_6, tmp_7, tmp_8, DepartmentRepository$allCacheStrategy$lambda_0);
  var tmp_9 = this;
  var tmp_10 = DepartmentRepository$getByIdStrategy$slambda_0(this, null);
  var tmp_11 = DepartmentRepository$getByIdStrategy$lambda;
  tmp_9.w7b_1 = new SimpleGetEndpointCacheStrategy(this.s7b_1, tmp_10, tmp_11, DepartmentRepository$getByIdStrategy$lambda_0);
}
function LocationRepository$authorizedCacheStrategy$slambda(this$0, resultContinuation) {
  this.e7e_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(LocationRepository$authorizedCacheStrategy$slambda).g7e = function (it, $completion) {
  var tmp = this.h7e(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(LocationRepository$authorizedCacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.g7e((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(LocationRepository$authorizedCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.e7e_1.i7e_1.m2u(this.f7e_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(LocationRepository$authorizedCacheStrategy$slambda).h7e = function (it, completion) {
  var i = new LocationRepository$authorizedCacheStrategy$slambda(this.e7e_1, completion);
  i.f7e_1 = it;
  return i;
};
function LocationRepository$authorizedCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new LocationRepository$authorizedCacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.g7e(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function LocationRepository$authorizedCacheStrategy$slambda_1(this$0, resultContinuation) {
  this.v7e_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(LocationRepository$authorizedCacheStrategy$slambda_1).w7e = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(LocationRepository$authorizedCacheStrategy$slambda_1).ma = function ($completion) {
  return this.w7e($completion);
};
protoOf(LocationRepository$authorizedCacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.v7e_1.k7e_1.x7e(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(LocationRepository$authorizedCacheStrategy$slambda_1).m32 = function (completion) {
  return new LocationRepository$authorizedCacheStrategy$slambda_1(this.v7e_1, completion);
};
function LocationRepository$authorizedCacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new LocationRepository$authorizedCacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.w7e($completion);
  };
  l.$arity = 0;
  return l;
}
function LocationRepository$authorizedCacheStrategy$lambda(it) {
  return toDomain_1(it);
}
function LocationRepository$authorizedCacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.y7e_1;
}
function LocationRepository$getByIdStrategy$slambda(this$0, resultContinuation) {
  this.l7g_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(LocationRepository$getByIdStrategy$slambda).n7g = function (id, $completion) {
  var tmp = this.u7d(id, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(LocationRepository$getByIdStrategy$slambda).h9 = function (p1, $completion) {
  return this.n7g(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(LocationRepository$getByIdStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.l7g_1.k7e_1.o7g(this.m7g_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(LocationRepository$getByIdStrategy$slambda).u7d = function (id, completion) {
  var i = new LocationRepository$getByIdStrategy$slambda(this.l7g_1, completion);
  i.m7g_1 = id;
  return i;
};
function LocationRepository$getByIdStrategy$slambda_0(this$0, resultContinuation) {
  var i = new LocationRepository$getByIdStrategy$slambda(this$0, resultContinuation);
  var l = function (id, $completion) {
    return i.n7g(id, $completion);
  };
  l.$arity = 1;
  return l;
}
function LocationRepository$getByIdStrategy$lambda(it) {
  return toDomain_1(it);
}
function LocationRepository$getByIdStrategy$lambda_0($this$SimpleGetEndpointCacheStrategy) {
  return $this$SimpleGetEndpointCacheStrategy.y7e_1;
}
function LocationRepository(authorizedLocalSource, getByIdLocalSource, remoteSource) {
  this.i7e_1 = authorizedLocalSource;
  this.j7e_1 = getByIdLocalSource;
  this.k7e_1 = remoteSource;
  var tmp = this;
  var tmp_0 = this.i7e_1.n18();
  var tmp_1 = LocationRepository$authorizedCacheStrategy$slambda_0(this, null);
  var tmp_2 = LocationRepository$authorizedCacheStrategy$slambda_2(this, null);
  var tmp_3 = LocationRepository$authorizedCacheStrategy$lambda;
  tmp.l7e_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, LocationRepository$authorizedCacheStrategy$lambda_0);
  var tmp_4 = this;
  var tmp_5 = LocationRepository$getByIdStrategy$slambda_0(this, null);
  var tmp_6 = LocationRepository$getByIdStrategy$lambda;
  tmp_4.m7e_1 = new SimpleGetEndpointCacheStrategy(this.j7e_1, tmp_5, tmp_6, LocationRepository$getByIdStrategy$lambda_0);
}
function ReferralRepository(remoteSource, sessionDataProvider) {
  this.p7g_1 = remoteSource;
  this.q7g_1 = sessionDataProvider;
}
function getRemoteApiData($this, $completion) {
  var tmp = new $getRemoteApiDataCOROUTINE$7($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
}
function RoleRepository$authorizedCacheStrategy$slambda(this$0, resultContinuation) {
  this.v7h_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RoleRepository$authorizedCacheStrategy$slambda).x7h = function (it, $completion) {
  var tmp = this.y7h(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(RoleRepository$authorizedCacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.x7h((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(RoleRepository$authorizedCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.v7h_1.z7h_1.m2u(this.w7h_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(RoleRepository$authorizedCacheStrategy$slambda).y7h = function (it, completion) {
  var i = new RoleRepository$authorizedCacheStrategy$slambda(this.v7h_1, completion);
  i.w7h_1 = it;
  return i;
};
function RoleRepository$authorizedCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new RoleRepository$authorizedCacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.x7h(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function RoleRepository$authorizedCacheStrategy$slambda_1(this$0, resultContinuation) {
  this.m7i_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RoleRepository$authorizedCacheStrategy$slambda_1).n7i = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(RoleRepository$authorizedCacheStrategy$slambda_1).ma = function ($completion) {
  return this.n7i($completion);
};
protoOf(RoleRepository$authorizedCacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = getRemoteApiData(this.m7i_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(RoleRepository$authorizedCacheStrategy$slambda_1).m32 = function (completion) {
  return new RoleRepository$authorizedCacheStrategy$slambda_1(this.m7i_1, completion);
};
function RoleRepository$authorizedCacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new RoleRepository$authorizedCacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.n7i($completion);
  };
  l.$arity = 0;
  return l;
}
function RoleRepository$authorizedCacheStrategy$lambda(it) {
  return toDomain_2(it);
}
function RoleRepository$authorizedCacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.o7i_1;
}
function RoleRepository$getByIdStrategy$slambda(this$0, resultContinuation) {
  this.c7j_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RoleRepository$getByIdStrategy$slambda).e7j = function (id, $completion) {
  var tmp = this.u7d(id, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(RoleRepository$getByIdStrategy$slambda).h9 = function (p1, $completion) {
  return this.e7j(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
};
protoOf(RoleRepository$getByIdStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.c7j_1.b7i_1.f7j(this.d7j_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(RoleRepository$getByIdStrategy$slambda).u7d = function (id, completion) {
  var i = new RoleRepository$getByIdStrategy$slambda(this.c7j_1, completion);
  i.d7j_1 = id;
  return i;
};
function RoleRepository$getByIdStrategy$slambda_0(this$0, resultContinuation) {
  var i = new RoleRepository$getByIdStrategy$slambda(this$0, resultContinuation);
  var l = function (id, $completion) {
    return i.e7j(id, $completion);
  };
  l.$arity = 1;
  return l;
}
function RoleRepository$getByIdStrategy$lambda(it) {
  return toDomain_2(it);
}
function RoleRepository$getByIdStrategy$lambda_0($this$SimpleGetEndpointCacheStrategy) {
  return $this$SimpleGetEndpointCacheStrategy.o7i_1;
}
function $getRemoteApiDataCOROUTINE$7(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z7g_1 = _this__u8e3s4;
}
protoOf($getRemoteApiDataCOROUTINE$7).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 8;
          this.n8_1 = 1;
          suspendResult = this.z7g_1.b7i_1.g7j(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          this.a7h_1 = suspendResult.ul_1;
          suspendResult = new Result(this.a7h_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.b7h_1 = suspendResult.ul_1;
          this.c7h_1 = this.b7h_1;
          if (_Result___get_isSuccess__impl__sndoy8(this.c7h_1)) {
            var tmp_0 = this;
            tmp_0.e7h_1 = new Result(this.c7h_1);
            this.f7h_1 = this.e7h_1;
            this.o8_1 = 5;
            var tmp_1 = this;
            tmp_1.h7h_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.i7h_1 = this.f7h_1.ul_1;
            this.j7h_1 = this.i7h_1;
            var tmp_3 = this;
            var tmp_4 = _Result___get_value__impl__bjfvqg(this.j7h_1);
            tmp_3.k7h_1 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
            this.l7h_1 = this.k7h_1;
            var tmp_5 = this;
            var this_0 = this.l7h_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.j();
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              destination.e(item.x79_1);
            }
            tmp_5.m7h_1 = toSet(destination);
            this.n8_1 = 3;
            suspendResult = this.z7g_1.b7i_1.h7j(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            this.n8_1 = 4;
            continue $sm;
          } else {
            this.d7h_1 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this.c7h_1));
            this.n8_1 = 7;
            continue $sm;
          }

        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var this_1 = suspendResult.ul_1;
          throwOnFailure(this_1);
          var tmp_6 = _Result___get_value__impl__bjfvqg(this_1);
          var tmp0 = (tmp_6 == null ? true : !(tmp_6 == null)) ? tmp_6 : THROW_CCE();
          var destination_0 = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s_0 = tmp0.j();
          while (_iterator__ex2g4s_0.k()) {
            var element = _iterator__ex2g4s_0.l();
            if (this.m7h_1.u1(element.k79_1)) {
              destination_0.e(element);
            }
          }

          var tmp_7 = this;
          this.h7h_1;
          tmp_7.g7h_1 = _Result___init__impl__xyqfz8(destination_0);
          this.o8_1 = 8;
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.o8_1 = 8;
          var tmp_8 = this.q8_1;
          if (tmp_8 instanceof Error) {
            var e = this.q8_1;
            var tmp_9 = this;
            tmp_9.g7h_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 6;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 6:
          this.o8_1 = 8;
          this.d7h_1 = this.g7h_1;
          this.n8_1 = 7;
          continue $sm;
        case 7:
          return new Result(this.d7h_1);
        case 8:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 8) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function RoleRepository(authorizedLocalSource, getByIdLocalSource, remoteSource) {
  this.z7h_1 = authorizedLocalSource;
  this.a7i_1 = getByIdLocalSource;
  this.b7i_1 = remoteSource;
  var tmp = this;
  var tmp_0 = this.z7h_1.n18();
  var tmp_1 = RoleRepository$authorizedCacheStrategy$slambda_0(this, null);
  var tmp_2 = RoleRepository$authorizedCacheStrategy$slambda_2(this, null);
  var tmp_3 = RoleRepository$authorizedCacheStrategy$lambda;
  tmp.c7i_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, RoleRepository$authorizedCacheStrategy$lambda_0);
  var tmp_4 = this;
  var tmp_5 = RoleRepository$getByIdStrategy$slambda_0(this, null);
  var tmp_6 = RoleRepository$getByIdStrategy$lambda;
  tmp_4.d7i_1 = new SimpleGetEndpointCacheStrategy(this.a7i_1, tmp_5, tmp_6, RoleRepository$getByIdStrategy$lambda_0);
}
function DayOfWeekSerializer() {
  DayOfWeekSerializer_instance = this;
  this.i7j_1 = PrimitiveSerialDescriptor('DayOfWeek', INT_getInstance());
}
protoOf(DayOfWeekSerializer).xn = function () {
  return this.i7j_1;
};
protoOf(DayOfWeekSerializer).j7j = function (encoder, value) {
  var adjusted = value.l2_1 === 7 ? 0 : value.l2_1;
  encoder.js(adjusted);
};
protoOf(DayOfWeekSerializer).yn = function (encoder, value) {
  return this.j7j(encoder, value instanceof DayOfWeek ? value : THROW_CCE());
};
protoOf(DayOfWeekSerializer).zn = function (decoder) {
  var intValue = decoder.ar();
  var adjusted = intValue === 0 ? 7 : intValue;
  return DayOfWeek_0(adjusted);
};
var DayOfWeekSerializer_instance;
function DayOfWeekSerializer_getInstance() {
  if (DayOfWeekSerializer_instance == null)
    new DayOfWeekSerializer();
  return DayOfWeekSerializer_instance;
}
function CompanyRemoteSource$getCompanySettings$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function CompanyRemoteSource$getCompanySettings$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getCompanySettingsCOROUTINE$9(_this__u8e3s4, companyId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s7j_1 = _this__u8e3s4;
  this.t7j_1 = companyId;
}
protoOf($getCompanySettingsCOROUTINE$9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.u7j_1 = this.s7j_1.m7l_1;
          var tmp_1 = this;
          tmp_1.v7j_1 = 'companies/' + this.t7j_1.toString() + '/settings';
          var tmp_2 = this;
          tmp_2.w7j_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.x7j_1 = this.u7j_1;
          this.y7j_1 = this.v7j_1;
          this.z7j_1 = this.w7j_1;
          var tmp_3 = this;
          tmp_3.a7k_1 = CompanyRemoteSource$getCompanySettings$lambda;
          this.o8_1 = 2;
          var tmp_4 = this;
          tmp_4.c7k_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.d7k_1 = this.x7j_1.f6l_1;
          var tmp_6 = this;
          tmp_6.e7k_1 = buildV2Path(this.x7j_1, this.y7j_1);
          this.f7k_1 = this.d7k_1;
          this.g7k_1 = this.e7k_1;
          var tmp_7 = this;
          tmp_7.h7k_1 = this.f7k_1;
          this.i7k_1 = this.h7k_1;
          var tmp_8 = this;
          tmp_8.j7k_1 = this.i7k_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.g7k_1);
          headers(this_0, CompanyRemoteSource$getCompanySettings$lambda_0(this.z7j_1));
          this_0.z5n(this.a7k_1);
          tmp_9.k7k_1 = this_0;
          this.l7k_1 = this.j7k_1;
          this.m7k_1 = this.k7k_1;
          this.m7k_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.n7k_1 = this.l7k_1;
          var tmp_11 = this;
          tmp_11.o7k_1 = this.m7k_1;
          this.p7k_1 = this.n7k_1;
          this.q7k_1 = this.o7k_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.q7k_1, this.p7k_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.r7k_1 = suspendResult;
          var tmp_12 = this;
          this.c7k_1;
          var value = this.r7k_1;
          tmp_12.b7k_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.s7k_1 = this.q8_1;
            var tmp_14 = this;
            throw this.s7k_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.t7k_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.t7k_1;
              tmp_16.b7k_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.u7k_1 = this.b7k_1;
          this.v7k_1 = this.u7k_1;
          this.w7k_1 = Result__exceptionOrNull_impl_p6xea9(this.v7k_1);
          if (this.w7k_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.v7k_1);
            tmp_17.y7k_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.z7k_1 = this.y7k_1;
            var tmp_19 = this;
            tmp_19.a7l_1 = this.z7k_1;
            this.b7l_1 = this.a7l_1;
            this.c7l_1 = this.b7l_1.c4u().z43_1;
            var containsArg = this.c7l_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_20 = this;
              tmp_20.f7l_1 = Companion_instance;
              if (getKClass(ApiCompanySettings).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.h7l_1 = this.b7l_1;
                this.i7l_1 = this.h7l_1;
                this.n8_1 = 6;
                var tmp_22 = this.i7l_1.y4u();
                var tmp_23 = getKClass(ApiCompanySettings);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiCompanySettings), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.j7l_1 = this.b7l_1;
                this.k7l_1 = this.j7l_1;
                this.n8_1 = 5;
                var tmp_27 = this.k7l_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.l7l_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.b7l_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.w7k_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.x7k_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.l7l_1;
          tmp_33.d7l_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiCompanySettings), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.g7l_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_37 = this;
          tmp_37.g7l_1 = suspendResult instanceof ApiCompanySettings ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.g7l_1;
          var tmp_38 = this;
          this.f7l_1;
          tmp_38.e7l_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.e7l_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_43 = this;
          var this_2 = this.e7l_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.d7l_1 = tmp_44.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.x7k_1 = new Result(this.d7l_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          var this_3 = this.x7k_1.ul_1;
          var tmp_46;
          if (_Result___get_isSuccess__impl__sndoy8(this_3)) {
            var tmp_47 = _Result___get_value__impl__bjfvqg(this_3);
            var it_0 = (tmp_47 == null ? true : !(tmp_47 == null)) ? tmp_47 : THROW_CCE();
            var value_1 = toDomain(it_0);
            tmp_46 = _Result___init__impl__xyqfz8(value_1);
          } else {
            tmp_46 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_3));
          }

          return new Result(tmp_46);
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function CompanyRemoteSource(apiClient) {
  this.m7l_1 = apiClient;
}
protoOf(CompanyRemoteSource).d7b = function (companyId, $completion) {
  var tmp = new $getCompanySettingsCOROUTINE$9(this, companyId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function IDepartmentRemoteSource() {
}
function DepartmentRemoteSource$listAuthorized$slambda$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function DepartmentRemoteSource$listAuthorized$slambda$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function DepartmentRemoteSource$listAll$slambda$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function DepartmentRemoteSource$listAll$slambda$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function DepartmentRemoteSource$listAll$slambda$lambda_1($cursor, $itemsPerPage, $block) {
  return function ($this$url, it) {
    var tmp0_safe_receiver = $cursor._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$url.o44_1.r3q('cursor', tmp0_safe_receiver);
    }
    $this$url.o44_1.r3q('limit', $itemsPerPage.toString());
    $block($this$url, $this$url);
    return Unit_instance;
  };
}
function Companion_5() {
  Companion_instance_7 = this;
  this.n7l_1 = ApiVersion_FEBRUARY_2026_getInstance();
}
var Companion_instance_7;
function Companion_getInstance_8() {
  if (Companion_instance_7 == null)
    new Companion_5();
  return Companion_instance_7;
}
function basePath($this, $completion) {
  var tmp = new $basePathCOROUTINE$10($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function DepartmentRemoteSource$listAuthorized$slambda(this$0, resultContinuation) {
  this.f7m_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRemoteSource$listAuthorized$slambda).g7c = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(DepartmentRemoteSource$listAuthorized$slambda).ma = function ($completion) {
  return this.g7c($completion);
};
protoOf(DepartmentRemoteSource$listAuthorized$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          var tmp_0 = this;
          tmp_0.g7m_1 = this.f7m_1.b7o_1;
          this.n8_1 = 1;
          suspendResult = basePath(this.f7m_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.h7m_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.f7m_1.c7o_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.i7m_1 = suspendResult;
          this.j7m_1 = this.i7m_1.toString();
          this.k7m_1 = this.h7m_1 + '/users/' + this.j7m_1 + '/authorized_departments';
          var tmp_1 = this;
          tmp_1.l7m_1 = Companion_getInstance_8().n7l_1;
          this.m7m_1 = this.g7m_1;
          this.n7m_1 = this.k7m_1;
          this.o7m_1 = this.l7m_1;
          var tmp_2 = this;
          tmp_2.p7m_1 = DepartmentRemoteSource$listAuthorized$slambda$lambda;
          this.o8_1 = 4;
          var tmp_3 = this;
          tmp_3.r7m_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.s7m_1 = this.m7m_1.f6l_1;
          var tmp_5 = this;
          tmp_5.t7m_1 = buildV2Path(this.m7m_1, this.n7m_1);
          this.u7m_1 = this.s7m_1;
          this.v7m_1 = this.t7m_1;
          var tmp_6 = this;
          tmp_6.w7m_1 = this.u7m_1;
          this.x7m_1 = this.w7m_1;
          var tmp_7 = this;
          tmp_7.y7m_1 = this.x7m_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.v7m_1);
          headers(this_0, DepartmentRemoteSource$listAuthorized$slambda$lambda_0(this.o7m_1));
          this_0.z5n(this.p7m_1);
          tmp_8.z7m_1 = this_0;
          this.a7n_1 = this.y7m_1;
          this.b7n_1 = this.z7m_1;
          this.b7n_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.c7n_1 = this.a7n_1;
          var tmp_10 = this;
          tmp_10.d7n_1 = this.b7n_1;
          this.e7n_1 = this.c7n_1;
          this.f7n_1 = this.d7n_1;
          this.n8_1 = 3;
          suspendResult = (new HttpStatement(this.f7n_1, this.e7n_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.g7n_1 = suspendResult;
          var tmp_11 = this;
          this.r7m_1;
          var value = this.g7n_1;
          tmp_11.q7m_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 14;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 14;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.h7n_1 = this.q8_1;
            var tmp_13 = this;
            throw this.h7n_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.i7n_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.i7n_1;
              tmp_15.q7m_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 5;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 5:
          this.o8_1 = 14;
          this.j7n_1 = this.q7m_1;
          this.k7n_1 = this.j7n_1;
          this.l7n_1 = Result__exceptionOrNull_impl_p6xea9(this.k7n_1);
          if (this.l7n_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.k7n_1);
            tmp_16.n7n_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.o7n_1 = this.n7n_1;
            var tmp_18 = this;
            tmp_18.p7n_1 = this.o7n_1;
            this.q7n_1 = this.p7n_1;
            this.r7n_1 = this.q7n_1.c4u().z43_1;
            var containsArg = this.r7n_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 10;
              var tmp_19 = this;
              tmp_19.u7n_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.w7n_1 = this.q7n_1;
                this.x7n_1 = this.w7n_1;
                this.n8_1 = 8;
                var tmp_21 = this.x7n_1.y4u();
                var tmp_22 = getKClass(KtList);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiAuthorizedDepartment), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.y7n_1 = this.q7n_1;
                this.z7n_1 = this.y7n_1;
                this.n8_1 = 7;
                var tmp_26 = this.z7n_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.a7o_1 = Companion_instance;
              this.n8_1 = 6;
              suspendResult = mapApiErrorResponse(this.q7n_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.l7n_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.m7n_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 13;
            continue $sm;
          }

        case 6:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.a7o_1;
          tmp_32.s7n_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 12;
          continue $sm;
        case 7:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiAuthorizedDepartment), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.v7n_1 = tmp$ret$0;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          var tmp_36 = this;
          tmp_36.v7n_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 9;
          continue $sm;
        case 9:
          var tmp1 = this.v7n_1;
          var tmp_37 = this;
          this.u7n_1;
          tmp_37.t7n_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 14;
          this.n8_1 = 11;
          continue $sm;
        case 10:
          this.o8_1 = 14;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.t7n_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 11;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 11:
          this.o8_1 = 14;
          var tmp_42 = this;
          var this_2 = this.t7n_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.s7n_1 = tmp_43.ul_1;
          this.n8_1 = 12;
          continue $sm;
        case 12:
          this.m7n_1 = new Result(this.s7n_1);
          this.n8_1 = 13;
          continue $sm;
        case 13:
          return this.m7n_1;
        case 14:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 14) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
protoOf(DepartmentRemoteSource$listAuthorized$slambda).m32 = function (completion) {
  return new DepartmentRemoteSource$listAuthorized$slambda(this.f7m_1, completion);
};
function DepartmentRemoteSource$listAuthorized$slambda_0(this$0, resultContinuation) {
  var i = new DepartmentRemoteSource$listAuthorized$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.g7c($completion);
  };
  l.$arity = 0;
  return l;
}
function DepartmentRemoteSource$listAll$slambda(this$0, resultContinuation) {
  this.n7o_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DepartmentRemoteSource$listAll$slambda).h7d = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(DepartmentRemoteSource$listAll$slambda).ma = function ($completion) {
  return this.h7d($completion);
};
protoOf(DepartmentRemoteSource$listAll$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 18;
          var tmp_0 = this;
          tmp_0.o7o_1 = this.n7o_1.b7o_1;
          this.n8_1 = 1;
          suspendResult = basePath(this.n7o_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.p7o_1 = suspendResult;
          this.q7o_1 = this.p7o_1 + '/departments';
          var tmp_1 = this;
          tmp_1.r7o_1 = Companion_getInstance_8().n7l_1;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.t7o_1 = this.o7o_1;
          this.u7o_1 = this.q7o_1;
          this.v7o_1 = this.r7o_1;
          var tmp_2 = this;
          tmp_2.w7o_1 = 100;
          var tmp_3 = this;
          tmp_3.x7o_1 = DepartmentRemoteSource$listAll$slambda$lambda;
          this.y7o_1 = {_v: null};
          var tmp_4 = this;
          tmp_4.z7o_1 = ArrayList_init_$Create$_0();
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 5;
          var tmp_5 = this;
          tmp_5.b7p_1 = Companion_instance;
          var tmp_6 = this;
          tmp_6.c7p_1 = this.t7o_1.f6l_1;
          var tmp_7 = this;
          tmp_7.d7p_1 = buildV2Path(this.t7o_1, this.u7o_1);
          this.e7p_1 = this.c7p_1;
          this.f7p_1 = this.d7p_1;
          var tmp_8 = this;
          tmp_8.g7p_1 = this.e7p_1;
          this.h7p_1 = this.g7p_1;
          var tmp_9 = this;
          tmp_9.i7p_1 = this.h7p_1;
          var tmp_10 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.f7p_1);
          headers(this_0, DepartmentRemoteSource$listAll$slambda$lambda_0(this.v7o_1));
          this_0.z5n(DepartmentRemoteSource$listAll$slambda$lambda_1(this.y7o_1, this.w7o_1, this.x7o_1));
          tmp_10.j7p_1 = this_0;
          this.k7p_1 = this.i7p_1;
          this.l7p_1 = this.j7p_1;
          this.l7p_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_11 = this;
          tmp_11.m7p_1 = this.k7p_1;
          var tmp_12 = this;
          tmp_12.n7p_1 = this.l7p_1;
          this.o7p_1 = this.m7p_1;
          this.p7p_1 = this.n7p_1;
          this.n8_1 = 4;
          suspendResult = (new HttpStatement(this.p7p_1, this.o7p_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.q7p_1 = suspendResult;
          var tmp_13 = this;
          this.b7p_1;
          var value = this.q7p_1;
          tmp_13.a7p_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 18;
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.o8_1 = 18;
          var tmp_14 = this.q8_1;
          if (tmp_14 instanceof CancellationException) {
            this.r7p_1 = this.q8_1;
            var tmp_15 = this;
            throw this.r7p_1;
          } else {
            var tmp_16 = this.q8_1;
            if (tmp_16 instanceof Error) {
              this.s7p_1 = this.q8_1;
              var tmp_17 = this;
              var exception = this.s7p_1;
              tmp_17.a7p_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 6;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 6:
          this.o8_1 = 18;
          this.t7p_1 = this.a7p_1;
          this.u7p_1 = this.t7p_1;
          this.v7p_1 = Result__exceptionOrNull_impl_p6xea9(this.u7p_1);
          if (this.v7p_1 == null) {
            var tmp_18 = this;
            var tmp_19 = _Result___get_value__impl__bjfvqg(this.u7p_1);
            tmp_18.x7p_1 = (tmp_19 == null ? true : !(tmp_19 == null)) ? tmp_19 : THROW_CCE();
            this.y7p_1 = this.x7p_1;
            var tmp_20 = this;
            tmp_20.z7p_1 = this.y7p_1;
            this.a7q_1 = this.z7p_1;
            this.b7q_1 = this.a7q_1.c4u().z43_1;
            var containsArg = this.b7q_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 11;
              var tmp_21 = this;
              tmp_21.e7q_1 = Companion_instance;
              if (getKClass(ApiPaginatedResponse).equals(getKClass(Unit))) {
                var tmp_22 = this;
                tmp_22.g7q_1 = this.a7q_1;
                this.h7q_1 = this.g7q_1;
                this.n8_1 = 9;
                var tmp_23 = this.h7q_1.y4u();
                var tmp_24 = getKClass(ApiPaginatedResponse);
                var tmp_25;
                try {
                  tmp_25 = createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiDepartment), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_26;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_26 = null;
                  } else {
                    throw $p;
                  }
                  tmp_25 = tmp_26;
                }
                suspendResult = tmp_23.a4u(new TypeInfo(tmp_24, tmp_25), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_27 = this;
                tmp_27.i7q_1 = this.a7q_1;
                this.j7q_1 = this.i7q_1;
                this.n8_1 = 8;
                var tmp_28 = this.j7q_1.y4u();
                var tmp_29 = getKClass(JsonElement);
                var tmp_30;
                try {
                  tmp_30 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_31;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_31 = null;
                  } else {
                    throw $p;
                  }
                  tmp_30 = tmp_31;
                }
                suspendResult = tmp_28.a4u(new TypeInfo(tmp_29, tmp_30), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_32 = this;
              tmp_32.k7q_1 = Companion_instance;
              this.n8_1 = 7;
              suspendResult = mapApiErrorResponse(this.a7q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_33 = this;
            var it = this.v7p_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_33.w7p_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 14;
            continue $sm;
          }

        case 7:
          var tmp4 = suspendResult;
          var tmp_34 = this;
          this.k7q_1;
          tmp_34.c7q_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 13;
          continue $sm;
        case 8:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_35 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiDepartment), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_36;
            if (tmp2 instanceof JsonObject) {
              tmp_36 = tmp2.c3p('data');
            } else {
              tmp_36 = false;
            }
            if (tmp_36) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_37;
              if (dataValue instanceof JsonObject) {
                tmp_37 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_37 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_37 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_37;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_35.f7q_1 = tmp$ret$0;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          var tmp_38 = this;
          tmp_38.f7q_1 = suspendResult instanceof ApiPaginatedResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 10;
          continue $sm;
        case 10:
          var tmp1 = this.f7q_1;
          var tmp_39 = this;
          this.e7q_1;
          tmp_39.d7q_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 18;
          this.n8_1 = 12;
          continue $sm;
        case 11:
          this.o8_1 = 18;
          var tmp_40 = this.q8_1;
          if (tmp_40 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_41 = this;
            throw e_0;
          } else {
            var tmp_42 = this.q8_1;
            if (tmp_42 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_43 = this;
              tmp_43.d7q_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 12;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 12:
          this.o8_1 = 18;
          var tmp_44 = this;
          var this_2 = this.d7q_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_45;
          if (exception_1 == null) {
            var tmp_46 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_46 == null ? true : !(tmp_46 == null)) ? tmp_46 : THROW_CCE();
            tmp_45 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_45 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_44.c7q_1 = tmp_45.ul_1;
          this.n8_1 = 13;
          continue $sm;
        case 13:
          this.w7p_1 = new Result(this.c7q_1);
          this.n8_1 = 14;
          continue $sm;
        case 14:
          var result = this.w7p_1.ul_1;
          var WHEN_RESULT;
          if (_Result___get_isFailure__impl__jpiriv(result)) {
            var tmp_47 = this;
            var tmp0_elvis_lhs = Result__exceptionOrNull_impl_p6xea9(result);
            var exception_3 = tmp0_elvis_lhs == null ? new Unknown() : tmp0_elvis_lhs;
            tmp_47.s7o_1 = _Result___init__impl__xyqfz8(createFailure(exception_3));
            this.n8_1 = 17;
            continue $sm;
          } else {
            var tmp_48;
            if (_Result___get_isFailure__impl__jpiriv(result)) {
              tmp_48 = null;
            } else {
              var tmp_49 = _Result___get_value__impl__bjfvqg(result);
              tmp_48 = (tmp_49 == null ? true : !(tmp_49 == null)) ? tmp_49 : THROW_CCE();
            }
            var paginatedResponse = tmp_48;
            var tmp2_safe_receiver = paginatedResponse == null ? null : paginatedResponse.o6m_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b6m_1;
            this.y7o_1._v = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g6m_1;
            var tmp5_safe_receiver = paginatedResponse == null ? null : paginatedResponse.n6m_1;
            var tmp_50;
            if (tmp5_safe_receiver == null) {
              tmp_50 = null;
            } else {
              tmp_50 = this.z7o_1.n(tmp5_safe_receiver);
            }
            WHEN_RESULT = tmp_50;
            this.n8_1 = 15;
            continue $sm;
          }

        case 15:
          if (!(this.y7o_1._v == null)) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 16;
          continue $sm;
        case 16:
          var tmp_51 = this;
          var value_1 = this.z7o_1;
          tmp_51.s7o_1 = _Result___init__impl__xyqfz8(value_1);
          if (false) {
            this.n8_1 = 2;
            continue $sm;
          }

          this.n8_1 = 17;
          continue $sm;
        case 17:
          return new Result(this.s7o_1);
        case 18:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 18) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
protoOf(DepartmentRemoteSource$listAll$slambda).m32 = function (completion) {
  return new DepartmentRemoteSource$listAll$slambda(this.n7o_1, completion);
};
function DepartmentRemoteSource$listAll$slambda_0(this$0, resultContinuation) {
  var i = new DepartmentRemoteSource$listAll$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.h7d($completion);
  };
  l.$arity = 0;
  return l;
}
function DepartmentRemoteSource$getById$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function DepartmentRemoteSource$getById$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $basePathCOROUTINE$10(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w7l_1 = _this__u8e3s4;
}
protoOf($basePathCOROUTINE$10).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.w7l_1.c7o_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return 'company/' + ARGUMENT_0;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $getByIdCOROUTINE$11(_this__u8e3s4, id, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t7q_1 = _this__u8e3s4;
  this.u7q_1 = id;
}
protoOf($getByIdCOROUTINE$11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.v7q_1 = this.t7q_1.b7o_1;
          this.n8_1 = 1;
          suspendResult = basePath(this.t7q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.w7q_1 = suspendResult;
          this.x7q_1 = this.w7q_1 + '/departments/' + this.u7q_1.toString();
          var tmp_1 = this;
          tmp_1.y7q_1 = Companion_getInstance_8().n7l_1;
          this.z7q_1 = this.v7q_1;
          this.a7r_1 = this.x7q_1;
          this.b7r_1 = this.y7q_1;
          var tmp_2 = this;
          tmp_2.c7r_1 = DepartmentRemoteSource$getById$lambda;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.e7r_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.f7r_1 = this.z7q_1.f6l_1;
          var tmp_5 = this;
          tmp_5.g7r_1 = buildV2Path(this.z7q_1, this.a7r_1);
          this.h7r_1 = this.f7r_1;
          this.i7r_1 = this.g7r_1;
          var tmp_6 = this;
          tmp_6.j7r_1 = this.h7r_1;
          this.k7r_1 = this.j7r_1;
          var tmp_7 = this;
          tmp_7.l7r_1 = this.k7r_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.i7r_1);
          headers(this_0, DepartmentRemoteSource$getById$lambda_0(this.b7r_1));
          this_0.z5n(this.c7r_1);
          tmp_8.m7r_1 = this_0;
          this.n7r_1 = this.l7r_1;
          this.o7r_1 = this.m7r_1;
          this.o7r_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.p7r_1 = this.n7r_1;
          var tmp_10 = this;
          tmp_10.q7r_1 = this.o7r_1;
          this.r7r_1 = this.p7r_1;
          this.s7r_1 = this.q7r_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.s7r_1, this.r7r_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.t7r_1 = suspendResult;
          var tmp_11 = this;
          this.e7r_1;
          var value = this.t7r_1;
          tmp_11.d7r_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.u7r_1 = this.q8_1;
            var tmp_13 = this;
            throw this.u7r_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.v7r_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.v7r_1;
              tmp_15.d7r_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.w7r_1 = this.d7r_1;
          this.x7r_1 = this.w7r_1;
          this.y7r_1 = Result__exceptionOrNull_impl_p6xea9(this.x7r_1);
          if (this.y7r_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.x7r_1);
            tmp_16.a7s_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.b7s_1 = this.a7s_1;
            var tmp_18 = this;
            tmp_18.c7s_1 = this.b7s_1;
            this.d7s_1 = this.c7s_1;
            this.e7s_1 = this.d7s_1.c4u().z43_1;
            var containsArg = this.e7s_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.h7s_1 = Companion_instance;
              if (getKClass(ApiAuthorizedDepartment).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.j7s_1 = this.d7s_1;
                this.k7s_1 = this.j7s_1;
                this.n8_1 = 7;
                var tmp_21 = this.k7s_1.y4u();
                var tmp_22 = getKClass(ApiAuthorizedDepartment);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(ApiAuthorizedDepartment), arrayOf([]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.l7s_1 = this.d7s_1;
                this.m7s_1 = this.l7s_1;
                this.n8_1 = 6;
                var tmp_26 = this.m7s_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.n7s_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.d7s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.y7r_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.z7r_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.n7s_1;
          tmp_32.f7s_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiAuthorizedDepartment), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.i7s_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.i7s_1 = suspendResult instanceof ApiAuthorizedDepartment ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.i7s_1;
          var tmp_37 = this;
          this.h7s_1;
          tmp_37.g7s_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.g7s_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.g7s_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.f7s_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.z7r_1 = new Result(this.f7s_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.z7r_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function DepartmentRemoteSource(apiClient, sessionDataProvider) {
  Companion_getInstance_8();
  this.b7o_1 = apiClient;
  this.c7o_1 = sessionDataProvider;
  this.d7o_1 = new NetworkJobManager();
  this.e7o_1 = new NetworkJobManager();
}
protoOf(DepartmentRemoteSource).h7c = function ($completion) {
  var tmp = this.d7o_1.n6q(VOID, DepartmentRemoteSource$listAuthorized$slambda_0(this, null), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
protoOf(DepartmentRemoteSource).i7d = function ($completion) {
  var tmp = this.e7o_1.n6q(VOID, DepartmentRemoteSource$listAll$slambda_0(this, null), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
protoOf(DepartmentRemoteSource).v7d = function (id, $completion) {
  var tmp = new $getByIdCOROUTINE$11(this, id, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function ICompanyRemoteSource() {
}
function ILocationRemoteSource() {
}
function IReferralRemoteSource() {
}
function IRoleRemoteSource() {
}
function LocationRemoteSource$list$slambda$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function LocationRemoteSource$list$slambda$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function Companion_6() {
  Companion_instance_8 = this;
  this.o7s_1 = ApiVersion_FEBRUARY_2026_getInstance();
}
var Companion_instance_8;
function Companion_getInstance_9() {
  if (Companion_instance_8 == null)
    new Companion_6();
  return Companion_instance_8;
}
function LocationRemoteSource$list$slambda(this$0, resultContinuation) {
  this.x7s_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(LocationRemoteSource$list$slambda).w7e = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(LocationRemoteSource$list$slambda).ma = function ($completion) {
  return this.w7e($completion);
};
protoOf(LocationRemoteSource$list$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          var tmp_0 = this;
          tmp_0.y7s_1 = this.x7s_1.u7u_1;
          this.n8_1 = 1;
          suspendResult = this.x7s_1.v7u_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.z7s_1 = suspendResult;
          this.a7t_1 = this.z7s_1.toString();
          this.n8_1 = 2;
          suspendResult = this.x7s_1.v7u_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.b7t_1 = suspendResult;
          this.c7t_1 = this.b7t_1.toString();
          this.d7t_1 = 'company/' + this.a7t_1 + '/users/' + this.c7t_1 + '/authorized_locations';
          var tmp_1 = this;
          tmp_1.e7t_1 = Companion_getInstance_9().o7s_1;
          this.f7t_1 = this.y7s_1;
          this.g7t_1 = this.d7t_1;
          this.h7t_1 = this.e7t_1;
          var tmp_2 = this;
          tmp_2.i7t_1 = LocationRemoteSource$list$slambda$lambda;
          this.o8_1 = 4;
          var tmp_3 = this;
          tmp_3.k7t_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.l7t_1 = this.f7t_1.f6l_1;
          var tmp_5 = this;
          tmp_5.m7t_1 = buildV2Path(this.f7t_1, this.g7t_1);
          this.n7t_1 = this.l7t_1;
          this.o7t_1 = this.m7t_1;
          var tmp_6 = this;
          tmp_6.p7t_1 = this.n7t_1;
          this.q7t_1 = this.p7t_1;
          var tmp_7 = this;
          tmp_7.r7t_1 = this.q7t_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.o7t_1);
          headers(this_0, LocationRemoteSource$list$slambda$lambda_0(this.h7t_1));
          this_0.z5n(this.i7t_1);
          tmp_8.s7t_1 = this_0;
          this.t7t_1 = this.r7t_1;
          this.u7t_1 = this.s7t_1;
          this.u7t_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.v7t_1 = this.t7t_1;
          var tmp_10 = this;
          tmp_10.w7t_1 = this.u7t_1;
          this.x7t_1 = this.v7t_1;
          this.y7t_1 = this.w7t_1;
          this.n8_1 = 3;
          suspendResult = (new HttpStatement(this.y7t_1, this.x7t_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.z7t_1 = suspendResult;
          var tmp_11 = this;
          this.k7t_1;
          var value = this.z7t_1;
          tmp_11.j7t_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 14;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 14;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.a7u_1 = this.q8_1;
            var tmp_13 = this;
            throw this.a7u_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.b7u_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.b7u_1;
              tmp_15.j7t_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 5;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 5:
          this.o8_1 = 14;
          this.c7u_1 = this.j7t_1;
          this.d7u_1 = this.c7u_1;
          this.e7u_1 = Result__exceptionOrNull_impl_p6xea9(this.d7u_1);
          if (this.e7u_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.d7u_1);
            tmp_16.g7u_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.h7u_1 = this.g7u_1;
            var tmp_18 = this;
            tmp_18.i7u_1 = this.h7u_1;
            this.j7u_1 = this.i7u_1;
            this.k7u_1 = this.j7u_1.c4u().z43_1;
            var containsArg = this.k7u_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 10;
              var tmp_19 = this;
              tmp_19.n7u_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.p7u_1 = this.j7u_1;
                this.q7u_1 = this.p7u_1;
                this.n8_1 = 8;
                var tmp_21 = this.q7u_1.y4u();
                var tmp_22 = getKClass(KtList);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiLocation), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.r7u_1 = this.j7u_1;
                this.s7u_1 = this.r7u_1;
                this.n8_1 = 7;
                var tmp_26 = this.s7u_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.t7u_1 = Companion_instance;
              this.n8_1 = 6;
              suspendResult = mapApiErrorResponse(this.j7u_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.e7u_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.f7u_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 13;
            continue $sm;
          }

        case 6:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.t7u_1;
          tmp_32.l7u_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 12;
          continue $sm;
        case 7:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiLocation), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.o7u_1 = tmp$ret$0;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          var tmp_36 = this;
          tmp_36.o7u_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 9;
          continue $sm;
        case 9:
          var tmp1 = this.o7u_1;
          var tmp_37 = this;
          this.n7u_1;
          tmp_37.m7u_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 14;
          this.n8_1 = 11;
          continue $sm;
        case 10:
          this.o8_1 = 14;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.m7u_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 11;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 11:
          this.o8_1 = 14;
          var tmp_42 = this;
          var this_2 = this.m7u_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.l7u_1 = tmp_43.ul_1;
          this.n8_1 = 12;
          continue $sm;
        case 12:
          this.f7u_1 = new Result(this.l7u_1);
          this.n8_1 = 13;
          continue $sm;
        case 13:
          return this.f7u_1;
        case 14:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 14) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
protoOf(LocationRemoteSource$list$slambda).m32 = function (completion) {
  return new LocationRemoteSource$list$slambda(this.x7s_1, completion);
};
function LocationRemoteSource$list$slambda_0(this$0, resultContinuation) {
  var i = new LocationRemoteSource$list$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.w7e($completion);
  };
  l.$arity = 0;
  return l;
}
function LocationRemoteSource$getById$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function LocationRemoteSource$getById$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getByIdCOROUTINE$14(_this__u8e3s4, id, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f7v_1 = _this__u8e3s4;
  this.g7v_1 = id;
}
protoOf($getByIdCOROUTINE$14).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.h7v_1 = this.f7v_1.u7u_1;
          this.n8_1 = 1;
          suspendResult = this.f7v_1.v7u_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.i7v_1 = suspendResult;
          this.j7v_1 = this.i7v_1.toString();
          this.k7v_1 = 'company/' + this.j7v_1 + '/locations/' + this.g7v_1.toString();
          var tmp_1 = this;
          tmp_1.l7v_1 = Companion_getInstance_9().o7s_1;
          this.m7v_1 = this.h7v_1;
          this.n7v_1 = this.k7v_1;
          this.o7v_1 = this.l7v_1;
          var tmp_2 = this;
          tmp_2.p7v_1 = LocationRemoteSource$getById$lambda;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.r7v_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.s7v_1 = this.m7v_1.f6l_1;
          var tmp_5 = this;
          tmp_5.t7v_1 = buildV2Path(this.m7v_1, this.n7v_1);
          this.u7v_1 = this.s7v_1;
          this.v7v_1 = this.t7v_1;
          var tmp_6 = this;
          tmp_6.w7v_1 = this.u7v_1;
          this.x7v_1 = this.w7v_1;
          var tmp_7 = this;
          tmp_7.y7v_1 = this.x7v_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.v7v_1);
          headers(this_0, LocationRemoteSource$getById$lambda_0(this.o7v_1));
          this_0.z5n(this.p7v_1);
          tmp_8.z7v_1 = this_0;
          this.a7w_1 = this.y7v_1;
          this.b7w_1 = this.z7v_1;
          this.b7w_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.c7w_1 = this.a7w_1;
          var tmp_10 = this;
          tmp_10.d7w_1 = this.b7w_1;
          this.e7w_1 = this.c7w_1;
          this.f7w_1 = this.d7w_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.f7w_1, this.e7w_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.g7w_1 = suspendResult;
          var tmp_11 = this;
          this.r7v_1;
          var value = this.g7w_1;
          tmp_11.q7v_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.h7w_1 = this.q8_1;
            var tmp_13 = this;
            throw this.h7w_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.i7w_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.i7w_1;
              tmp_15.q7v_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.j7w_1 = this.q7v_1;
          this.k7w_1 = this.j7w_1;
          this.l7w_1 = Result__exceptionOrNull_impl_p6xea9(this.k7w_1);
          if (this.l7w_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.k7w_1);
            tmp_16.n7w_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.o7w_1 = this.n7w_1;
            var tmp_18 = this;
            tmp_18.p7w_1 = this.o7w_1;
            this.q7w_1 = this.p7w_1;
            this.r7w_1 = this.q7w_1.c4u().z43_1;
            var containsArg = this.r7w_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.u7w_1 = Companion_instance;
              if (getKClass(ApiLocation).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.w7w_1 = this.q7w_1;
                this.x7w_1 = this.w7w_1;
                this.n8_1 = 7;
                var tmp_21 = this.x7w_1.y4u();
                var tmp_22 = getKClass(ApiLocation);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(ApiLocation), arrayOf([]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.y7w_1 = this.q7w_1;
                this.z7w_1 = this.y7w_1;
                this.n8_1 = 6;
                var tmp_26 = this.z7w_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.a7x_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.q7w_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.l7w_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.m7w_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.a7x_1;
          tmp_32.s7w_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiLocation), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.v7w_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.v7w_1 = suspendResult instanceof ApiLocation ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.v7w_1;
          var tmp_37 = this;
          this.u7w_1;
          tmp_37.t7w_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.t7w_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.t7w_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.s7w_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.m7w_1 = new Result(this.s7w_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.m7w_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function LocationRemoteSource(apiClient, sessionDataProvider) {
  Companion_getInstance_9();
  this.u7u_1 = apiClient;
  this.v7u_1 = sessionDataProvider;
  this.w7u_1 = new NetworkJobManager();
}
protoOf(LocationRemoteSource).x7e = function ($completion) {
  var tmp = this.w7u_1.n6q(VOID, LocationRemoteSource$list$slambda_0(this, null), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
protoOf(LocationRemoteSource).o7g = function (id, $completion) {
  var tmp = new $getByIdCOROUTINE$14(this, id, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function ReferralRemoteSource(apiClient) {
  this.b7x_1 = apiClient;
}
function RoleRemoteSource$listAuthorizedRoles$slambda$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function RoleRemoteSource$listAuthorizedRoles$slambda$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function RoleRemoteSource$listAuthorizedRoles$slambda$lambda_1($cursor, $itemsPerPage, $block) {
  return function ($this$url, it) {
    var tmp0_safe_receiver = $cursor._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$url.o44_1.r3q('cursor', tmp0_safe_receiver);
    }
    $this$url.o44_1.r3q('limit', $itemsPerPage.toString());
    $block($this$url, $this$url);
    return Unit_instance;
  };
}
function RoleRemoteSource$listAllRoles$slambda$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function RoleRemoteSource$listAllRoles$slambda$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function RoleRemoteSource$listAllRoles$slambda$lambda_1($cursor, $itemsPerPage, $block) {
  return function ($this$url, it) {
    var tmp0_safe_receiver = $cursor._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$url.o44_1.r3q('cursor', tmp0_safe_receiver);
    }
    $this$url.o44_1.r3q('limit', $itemsPerPage.toString());
    $block($this$url, $this$url);
    return Unit_instance;
  };
}
function Companion_7() {
  Companion_instance_9 = this;
  this.c7x_1 = ApiVersion_FEBRUARY_2026_getInstance();
}
var Companion_instance_9;
function Companion_getInstance_10() {
  if (Companion_instance_9 == null)
    new Companion_7();
  return Companion_instance_9;
}
function getBasePath($this, $completion) {
  var tmp = new $getBasePathCOROUTINE$20($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function RoleRemoteSource$listAuthorizedRoles$slambda(this$0, resultContinuation) {
  this.u7x_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RoleRemoteSource$listAuthorizedRoles$slambda).u7z = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(RoleRemoteSource$listAuthorizedRoles$slambda).ma = function ($completion) {
  return this.u7z($completion);
};
protoOf(RoleRemoteSource$listAuthorizedRoles$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 19;
          var tmp_0 = this;
          tmp_0.v7x_1 = this.u7x_1.v7z_1;
          this.n8_1 = 1;
          suspendResult = getBasePath(this.u7x_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.w7x_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.u7x_1.w7z_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.x7x_1 = suspendResult;
          this.y7x_1 = this.x7x_1.toString();
          this.z7x_1 = this.w7x_1 + '/users/' + this.y7x_1 + '/authorized_roles';
          var tmp_1 = this;
          tmp_1.a7y_1 = Companion_getInstance_10().c7x_1;
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.c7y_1 = this.v7x_1;
          this.d7y_1 = this.z7x_1;
          this.e7y_1 = this.a7y_1;
          var tmp_2 = this;
          tmp_2.f7y_1 = 100;
          var tmp_3 = this;
          tmp_3.g7y_1 = RoleRemoteSource$listAuthorizedRoles$slambda$lambda;
          this.h7y_1 = {_v: null};
          var tmp_4 = this;
          tmp_4.i7y_1 = ArrayList_init_$Create$_0();
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.o8_1 = 6;
          var tmp_5 = this;
          tmp_5.k7y_1 = Companion_instance;
          var tmp_6 = this;
          tmp_6.l7y_1 = this.c7y_1.f6l_1;
          var tmp_7 = this;
          tmp_7.m7y_1 = buildV2Path(this.c7y_1, this.d7y_1);
          this.n7y_1 = this.l7y_1;
          this.o7y_1 = this.m7y_1;
          var tmp_8 = this;
          tmp_8.p7y_1 = this.n7y_1;
          this.q7y_1 = this.p7y_1;
          var tmp_9 = this;
          tmp_9.r7y_1 = this.q7y_1;
          var tmp_10 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.o7y_1);
          headers(this_0, RoleRemoteSource$listAuthorizedRoles$slambda$lambda_0(this.e7y_1));
          this_0.z5n(RoleRemoteSource$listAuthorizedRoles$slambda$lambda_1(this.h7y_1, this.f7y_1, this.g7y_1));
          tmp_10.s7y_1 = this_0;
          this.t7y_1 = this.r7y_1;
          this.u7y_1 = this.s7y_1;
          this.u7y_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_11 = this;
          tmp_11.v7y_1 = this.t7y_1;
          var tmp_12 = this;
          tmp_12.w7y_1 = this.u7y_1;
          this.x7y_1 = this.v7y_1;
          this.y7y_1 = this.w7y_1;
          this.n8_1 = 5;
          suspendResult = (new HttpStatement(this.y7y_1, this.x7y_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.z7y_1 = suspendResult;
          var tmp_13 = this;
          this.k7y_1;
          var value = this.z7y_1;
          tmp_13.j7y_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 19;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          this.o8_1 = 19;
          var tmp_14 = this.q8_1;
          if (tmp_14 instanceof CancellationException) {
            this.a7z_1 = this.q8_1;
            var tmp_15 = this;
            throw this.a7z_1;
          } else {
            var tmp_16 = this.q8_1;
            if (tmp_16 instanceof Error) {
              this.b7z_1 = this.q8_1;
              var tmp_17 = this;
              var exception = this.b7z_1;
              tmp_17.j7y_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 7;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 7:
          this.o8_1 = 19;
          this.c7z_1 = this.j7y_1;
          this.d7z_1 = this.c7z_1;
          this.e7z_1 = Result__exceptionOrNull_impl_p6xea9(this.d7z_1);
          if (this.e7z_1 == null) {
            var tmp_18 = this;
            var tmp_19 = _Result___get_value__impl__bjfvqg(this.d7z_1);
            tmp_18.g7z_1 = (tmp_19 == null ? true : !(tmp_19 == null)) ? tmp_19 : THROW_CCE();
            this.h7z_1 = this.g7z_1;
            var tmp_20 = this;
            tmp_20.i7z_1 = this.h7z_1;
            this.j7z_1 = this.i7z_1;
            this.k7z_1 = this.j7z_1.c4u().z43_1;
            var containsArg = this.k7z_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 12;
              var tmp_21 = this;
              tmp_21.n7z_1 = Companion_instance;
              if (getKClass(ApiPaginatedResponse).equals(getKClass(Unit))) {
                var tmp_22 = this;
                tmp_22.p7z_1 = this.j7z_1;
                this.q7z_1 = this.p7z_1;
                this.n8_1 = 10;
                var tmp_23 = this.q7z_1.y4u();
                var tmp_24 = getKClass(ApiPaginatedResponse);
                var tmp_25;
                try {
                  tmp_25 = createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiAuthorizedRole), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_26;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_26 = null;
                  } else {
                    throw $p;
                  }
                  tmp_25 = tmp_26;
                }
                suspendResult = tmp_23.a4u(new TypeInfo(tmp_24, tmp_25), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_27 = this;
                tmp_27.r7z_1 = this.j7z_1;
                this.s7z_1 = this.r7z_1;
                this.n8_1 = 9;
                var tmp_28 = this.s7z_1.y4u();
                var tmp_29 = getKClass(JsonElement);
                var tmp_30;
                try {
                  tmp_30 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_31;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_31 = null;
                  } else {
                    throw $p;
                  }
                  tmp_30 = tmp_31;
                }
                suspendResult = tmp_28.a4u(new TypeInfo(tmp_29, tmp_30), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_32 = this;
              tmp_32.t7z_1 = Companion_instance;
              this.n8_1 = 8;
              suspendResult = mapApiErrorResponse(this.j7z_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_33 = this;
            var it = this.e7z_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_33.f7z_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 15;
            continue $sm;
          }

        case 8:
          var tmp4 = suspendResult;
          var tmp_34 = this;
          this.t7z_1;
          tmp_34.l7z_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 14;
          continue $sm;
        case 9:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_35 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiAuthorizedRole), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_36;
            if (tmp2 instanceof JsonObject) {
              tmp_36 = tmp2.c3p('data');
            } else {
              tmp_36 = false;
            }
            if (tmp_36) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_37;
              if (dataValue instanceof JsonObject) {
                tmp_37 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_37 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_37 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_37;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_35.o7z_1 = tmp$ret$0;
          this.n8_1 = 11;
          continue $sm;
        case 10:
          var tmp_38 = this;
          tmp_38.o7z_1 = suspendResult instanceof ApiPaginatedResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 11;
          continue $sm;
        case 11:
          var tmp1 = this.o7z_1;
          var tmp_39 = this;
          this.n7z_1;
          tmp_39.m7z_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 19;
          this.n8_1 = 13;
          continue $sm;
        case 12:
          this.o8_1 = 19;
          var tmp_40 = this.q8_1;
          if (tmp_40 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_41 = this;
            throw e_0;
          } else {
            var tmp_42 = this.q8_1;
            if (tmp_42 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_43 = this;
              tmp_43.m7z_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 13;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 13:
          this.o8_1 = 19;
          var tmp_44 = this;
          var this_2 = this.m7z_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_45;
          if (exception_1 == null) {
            var tmp_46 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_46 == null ? true : !(tmp_46 == null)) ? tmp_46 : THROW_CCE();
            tmp_45 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_45 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_44.l7z_1 = tmp_45.ul_1;
          this.n8_1 = 14;
          continue $sm;
        case 14:
          this.f7z_1 = new Result(this.l7z_1);
          this.n8_1 = 15;
          continue $sm;
        case 15:
          var result = this.f7z_1.ul_1;
          var WHEN_RESULT;
          if (_Result___get_isFailure__impl__jpiriv(result)) {
            var tmp_47 = this;
            var tmp0_elvis_lhs = Result__exceptionOrNull_impl_p6xea9(result);
            var exception_3 = tmp0_elvis_lhs == null ? new Unknown() : tmp0_elvis_lhs;
            tmp_47.b7y_1 = _Result___init__impl__xyqfz8(createFailure(exception_3));
            this.n8_1 = 18;
            continue $sm;
          } else {
            var tmp_48;
            if (_Result___get_isFailure__impl__jpiriv(result)) {
              tmp_48 = null;
            } else {
              var tmp_49 = _Result___get_value__impl__bjfvqg(result);
              tmp_48 = (tmp_49 == null ? true : !(tmp_49 == null)) ? tmp_49 : THROW_CCE();
            }
            var paginatedResponse = tmp_48;
            var tmp2_safe_receiver = paginatedResponse == null ? null : paginatedResponse.o6m_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b6m_1;
            this.h7y_1._v = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g6m_1;
            var tmp5_safe_receiver = paginatedResponse == null ? null : paginatedResponse.n6m_1;
            var tmp_50;
            if (tmp5_safe_receiver == null) {
              tmp_50 = null;
            } else {
              tmp_50 = this.i7y_1.n(tmp5_safe_receiver);
            }
            WHEN_RESULT = tmp_50;
            this.n8_1 = 16;
            continue $sm;
          }

        case 16:
          if (!(this.h7y_1._v == null)) {
            this.n8_1 = 4;
            continue $sm;
          }

          this.n8_1 = 17;
          continue $sm;
        case 17:
          var tmp_51 = this;
          var value_1 = this.i7y_1;
          tmp_51.b7y_1 = _Result___init__impl__xyqfz8(value_1);
          if (false) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 18;
          continue $sm;
        case 18:
          return new Result(this.b7y_1);
        case 19:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 19) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
protoOf(RoleRemoteSource$listAuthorizedRoles$slambda).m32 = function (completion) {
  return new RoleRemoteSource$listAuthorizedRoles$slambda(this.u7x_1, completion);
};
function RoleRemoteSource$listAuthorizedRoles$slambda_0(this$0, resultContinuation) {
  var i = new RoleRemoteSource$listAuthorizedRoles$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.u7z($completion);
  };
  l.$arity = 0;
  return l;
}
function RoleRemoteSource$listAllRoles$slambda(this$0, resultContinuation) {
  this.h80_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(RoleRemoteSource$listAllRoles$slambda).n7i = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(RoleRemoteSource$listAllRoles$slambda).ma = function ($completion) {
  return this.n7i($completion);
};
protoOf(RoleRemoteSource$listAllRoles$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 18;
          var tmp_0 = this;
          tmp_0.i80_1 = this.h80_1.v7z_1;
          this.n8_1 = 1;
          suspendResult = getBasePath(this.h80_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.j80_1 = suspendResult;
          this.k80_1 = this.j80_1 + '/roles';
          var tmp_1 = this;
          tmp_1.l80_1 = Companion_getInstance_10().c7x_1;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.n80_1 = this.i80_1;
          this.o80_1 = this.k80_1;
          this.p80_1 = this.l80_1;
          var tmp_2 = this;
          tmp_2.q80_1 = 100;
          var tmp_3 = this;
          tmp_3.r80_1 = RoleRemoteSource$listAllRoles$slambda$lambda;
          this.s80_1 = {_v: null};
          var tmp_4 = this;
          tmp_4.t80_1 = ArrayList_init_$Create$_0();
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 5;
          var tmp_5 = this;
          tmp_5.v80_1 = Companion_instance;
          var tmp_6 = this;
          tmp_6.w80_1 = this.n80_1.f6l_1;
          var tmp_7 = this;
          tmp_7.x80_1 = buildV2Path(this.n80_1, this.o80_1);
          this.y80_1 = this.w80_1;
          this.z80_1 = this.x80_1;
          var tmp_8 = this;
          tmp_8.a81_1 = this.y80_1;
          this.b81_1 = this.a81_1;
          var tmp_9 = this;
          tmp_9.c81_1 = this.b81_1;
          var tmp_10 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.z80_1);
          headers(this_0, RoleRemoteSource$listAllRoles$slambda$lambda_0(this.p80_1));
          this_0.z5n(RoleRemoteSource$listAllRoles$slambda$lambda_1(this.s80_1, this.q80_1, this.r80_1));
          tmp_10.d81_1 = this_0;
          this.e81_1 = this.c81_1;
          this.f81_1 = this.d81_1;
          this.f81_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_11 = this;
          tmp_11.g81_1 = this.e81_1;
          var tmp_12 = this;
          tmp_12.h81_1 = this.f81_1;
          this.i81_1 = this.g81_1;
          this.j81_1 = this.h81_1;
          this.n8_1 = 4;
          suspendResult = (new HttpStatement(this.j81_1, this.i81_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.k81_1 = suspendResult;
          var tmp_13 = this;
          this.v80_1;
          var value = this.k81_1;
          tmp_13.u80_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 18;
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.o8_1 = 18;
          var tmp_14 = this.q8_1;
          if (tmp_14 instanceof CancellationException) {
            this.l81_1 = this.q8_1;
            var tmp_15 = this;
            throw this.l81_1;
          } else {
            var tmp_16 = this.q8_1;
            if (tmp_16 instanceof Error) {
              this.m81_1 = this.q8_1;
              var tmp_17 = this;
              var exception = this.m81_1;
              tmp_17.u80_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 6;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 6:
          this.o8_1 = 18;
          this.n81_1 = this.u80_1;
          this.o81_1 = this.n81_1;
          this.p81_1 = Result__exceptionOrNull_impl_p6xea9(this.o81_1);
          if (this.p81_1 == null) {
            var tmp_18 = this;
            var tmp_19 = _Result___get_value__impl__bjfvqg(this.o81_1);
            tmp_18.r81_1 = (tmp_19 == null ? true : !(tmp_19 == null)) ? tmp_19 : THROW_CCE();
            this.s81_1 = this.r81_1;
            var tmp_20 = this;
            tmp_20.t81_1 = this.s81_1;
            this.u81_1 = this.t81_1;
            this.v81_1 = this.u81_1.c4u().z43_1;
            var containsArg = this.v81_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 11;
              var tmp_21 = this;
              tmp_21.y81_1 = Companion_instance;
              if (getKClass(ApiPaginatedResponse).equals(getKClass(Unit))) {
                var tmp_22 = this;
                tmp_22.a82_1 = this.u81_1;
                this.b82_1 = this.a82_1;
                this.n8_1 = 9;
                var tmp_23 = this.b82_1.y4u();
                var tmp_24 = getKClass(ApiPaginatedResponse);
                var tmp_25;
                try {
                  tmp_25 = createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiRole), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_26;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_26 = null;
                  } else {
                    throw $p;
                  }
                  tmp_25 = tmp_26;
                }
                suspendResult = tmp_23.a4u(new TypeInfo(tmp_24, tmp_25), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_27 = this;
                tmp_27.c82_1 = this.u81_1;
                this.d82_1 = this.c82_1;
                this.n8_1 = 8;
                var tmp_28 = this.d82_1.y4u();
                var tmp_29 = getKClass(JsonElement);
                var tmp_30;
                try {
                  tmp_30 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_31;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_31 = null;
                  } else {
                    throw $p;
                  }
                  tmp_30 = tmp_31;
                }
                suspendResult = tmp_28.a4u(new TypeInfo(tmp_29, tmp_30), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_32 = this;
              tmp_32.e82_1 = Companion_instance;
              this.n8_1 = 7;
              suspendResult = mapApiErrorResponse(this.u81_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_33 = this;
            var it = this.p81_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_33.q81_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 14;
            continue $sm;
          }

        case 7:
          var tmp4 = suspendResult;
          var tmp_34 = this;
          this.e82_1;
          tmp_34.w81_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 13;
          continue $sm;
        case 8:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_35 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiRole), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_36;
            if (tmp2 instanceof JsonObject) {
              tmp_36 = tmp2.c3p('data');
            } else {
              tmp_36 = false;
            }
            if (tmp_36) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_37;
              if (dataValue instanceof JsonObject) {
                tmp_37 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_37 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_37 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_37;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_35.z81_1 = tmp$ret$0;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          var tmp_38 = this;
          tmp_38.z81_1 = suspendResult instanceof ApiPaginatedResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 10;
          continue $sm;
        case 10:
          var tmp1 = this.z81_1;
          var tmp_39 = this;
          this.y81_1;
          tmp_39.x81_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 18;
          this.n8_1 = 12;
          continue $sm;
        case 11:
          this.o8_1 = 18;
          var tmp_40 = this.q8_1;
          if (tmp_40 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_41 = this;
            throw e_0;
          } else {
            var tmp_42 = this.q8_1;
            if (tmp_42 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_43 = this;
              tmp_43.x81_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 12;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 12:
          this.o8_1 = 18;
          var tmp_44 = this;
          var this_2 = this.x81_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_45;
          if (exception_1 == null) {
            var tmp_46 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_46 == null ? true : !(tmp_46 == null)) ? tmp_46 : THROW_CCE();
            tmp_45 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_45 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_44.w81_1 = tmp_45.ul_1;
          this.n8_1 = 13;
          continue $sm;
        case 13:
          this.q81_1 = new Result(this.w81_1);
          this.n8_1 = 14;
          continue $sm;
        case 14:
          var result = this.q81_1.ul_1;
          var WHEN_RESULT;
          if (_Result___get_isFailure__impl__jpiriv(result)) {
            var tmp_47 = this;
            var tmp0_elvis_lhs = Result__exceptionOrNull_impl_p6xea9(result);
            var exception_3 = tmp0_elvis_lhs == null ? new Unknown() : tmp0_elvis_lhs;
            tmp_47.m80_1 = _Result___init__impl__xyqfz8(createFailure(exception_3));
            this.n8_1 = 17;
            continue $sm;
          } else {
            var tmp_48;
            if (_Result___get_isFailure__impl__jpiriv(result)) {
              tmp_48 = null;
            } else {
              var tmp_49 = _Result___get_value__impl__bjfvqg(result);
              tmp_48 = (tmp_49 == null ? true : !(tmp_49 == null)) ? tmp_49 : THROW_CCE();
            }
            var paginatedResponse = tmp_48;
            var tmp2_safe_receiver = paginatedResponse == null ? null : paginatedResponse.o6m_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b6m_1;
            this.s80_1._v = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g6m_1;
            var tmp5_safe_receiver = paginatedResponse == null ? null : paginatedResponse.n6m_1;
            var tmp_50;
            if (tmp5_safe_receiver == null) {
              tmp_50 = null;
            } else {
              tmp_50 = this.t80_1.n(tmp5_safe_receiver);
            }
            WHEN_RESULT = tmp_50;
            this.n8_1 = 15;
            continue $sm;
          }

        case 15:
          if (!(this.s80_1._v == null)) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 16;
          continue $sm;
        case 16:
          var tmp_51 = this;
          var value_1 = this.t80_1;
          tmp_51.m80_1 = _Result___init__impl__xyqfz8(value_1);
          if (false) {
            this.n8_1 = 2;
            continue $sm;
          }

          this.n8_1 = 17;
          continue $sm;
        case 17:
          return new Result(this.m80_1);
        case 18:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 18) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
protoOf(RoleRemoteSource$listAllRoles$slambda).m32 = function (completion) {
  return new RoleRemoteSource$listAllRoles$slambda(this.h80_1, completion);
};
function RoleRemoteSource$listAllRoles$slambda_0(this$0, resultContinuation) {
  var i = new RoleRemoteSource$listAllRoles$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.n7i($completion);
  };
  l.$arity = 0;
  return l;
}
function RoleRemoteSource$getById$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function RoleRemoteSource$getById$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getByIdCOROUTINE$17(_this__u8e3s4, id, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n82_1 = _this__u8e3s4;
  this.o82_1 = id;
}
protoOf($getByIdCOROUTINE$17).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.p82_1 = this.n82_1.v7z_1;
          this.n8_1 = 1;
          suspendResult = getBasePath(this.n82_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.q82_1 = suspendResult;
          this.r82_1 = this.q82_1 + '/roles/' + this.o82_1.toString();
          var tmp_1 = this;
          tmp_1.s82_1 = Companion_getInstance_10().c7x_1;
          this.t82_1 = this.p82_1;
          this.u82_1 = this.r82_1;
          this.v82_1 = this.s82_1;
          var tmp_2 = this;
          tmp_2.w82_1 = RoleRemoteSource$getById$lambda;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.y82_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.z82_1 = this.t82_1.f6l_1;
          var tmp_5 = this;
          tmp_5.a83_1 = buildV2Path(this.t82_1, this.u82_1);
          this.b83_1 = this.z82_1;
          this.c83_1 = this.a83_1;
          var tmp_6 = this;
          tmp_6.d83_1 = this.b83_1;
          this.e83_1 = this.d83_1;
          var tmp_7 = this;
          tmp_7.f83_1 = this.e83_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.c83_1);
          headers(this_0, RoleRemoteSource$getById$lambda_0(this.v82_1));
          this_0.z5n(this.w82_1);
          tmp_8.g83_1 = this_0;
          this.h83_1 = this.f83_1;
          this.i83_1 = this.g83_1;
          this.i83_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.j83_1 = this.h83_1;
          var tmp_10 = this;
          tmp_10.k83_1 = this.i83_1;
          this.l83_1 = this.j83_1;
          this.m83_1 = this.k83_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.m83_1, this.l83_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n83_1 = suspendResult;
          var tmp_11 = this;
          this.y82_1;
          var value = this.n83_1;
          tmp_11.x82_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.o83_1 = this.q8_1;
            var tmp_13 = this;
            throw this.o83_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.p83_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.p83_1;
              tmp_15.x82_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.q83_1 = this.x82_1;
          this.r83_1 = this.q83_1;
          this.s83_1 = Result__exceptionOrNull_impl_p6xea9(this.r83_1);
          if (this.s83_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.r83_1);
            tmp_16.u83_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.v83_1 = this.u83_1;
            var tmp_18 = this;
            tmp_18.w83_1 = this.v83_1;
            this.x83_1 = this.w83_1;
            this.y83_1 = this.x83_1.c4u().z43_1;
            var containsArg = this.y83_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.b84_1 = Companion_instance;
              if (getKClass(ApiRole).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.d84_1 = this.x83_1;
                this.e84_1 = this.d84_1;
                this.n8_1 = 7;
                var tmp_21 = this.e84_1.y4u();
                var tmp_22 = getKClass(ApiRole);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(ApiRole), arrayOf([]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.f84_1 = this.x83_1;
                this.g84_1 = this.f84_1;
                this.n8_1 = 6;
                var tmp_26 = this.g84_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.h84_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.x83_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.s83_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.t83_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.h84_1;
          tmp_32.z83_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiRole), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.c84_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.c84_1 = suspendResult instanceof ApiRole ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.c84_1;
          var tmp_37 = this;
          this.b84_1;
          tmp_37.a84_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.a84_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.a84_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.z83_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.t83_1 = new Result(this.z83_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.t83_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $getBasePathCOROUTINE$20(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l7x_1 = _this__u8e3s4;
}
protoOf($getBasePathCOROUTINE$20).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.l7x_1.w7z_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return 'company/' + ARGUMENT_0;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function RoleRemoteSource(apiClient, sessionDataProvider) {
  Companion_getInstance_10();
  this.v7z_1 = apiClient;
  this.w7z_1 = sessionDataProvider;
  this.x7z_1 = new NetworkJobManager();
  this.y7z_1 = new NetworkJobManager();
}
protoOf(RoleRemoteSource).g7j = function ($completion) {
  var tmp = this.y7z_1.n6q(VOID, RoleRemoteSource$listAuthorizedRoles$slambda_0(this, null), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
protoOf(RoleRemoteSource).h7j = function ($completion) {
  var tmp = this.x7z_1.n6q(VOID, RoleRemoteSource$listAllRoles$slambda_0(this, null), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
protoOf(RoleRemoteSource).f7j = function (id, $completion) {
  var tmp = new $getByIdCOROUTINE$17(this, id, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_coreModule() {
  _init_properties_CoreModule_kt__is3d57();
  return coreModule;
}
var coreModule;
function coreModule$lambda($this$module) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = coreModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IReferralRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = coreModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IReferralAccessor), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp7 = new TypeQualifier(getKClass(CompanySettings));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = coreModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(ILocalSource), tmp7, definition, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = coreModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(ICompanyRemoteSource), null, tmp2_1, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = coreModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(ICompanyAccessor), null, tmp2_2, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp17 = new TypeQualifier(getKClass(Location));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = coreModule$lambda$lambda_4;
  var scopeQualifier_4 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Singleton_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(IListLocalSource), tmp17, definition_0, kind_4, secondaryTypes_4);
  var factory_4 = new SingleInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_4);
  }
  new KoinDefinition($this$module, factory_4);
  var tmp21 = named('location_get_by_id');
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = coreModule$lambda$lambda_5;
  var scopeQualifier_5 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Singleton_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(IListLocalSource), tmp21, definition_1, kind_5, secondaryTypes_5);
  var factory_5 = new SingleInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_5);
  }
  new KoinDefinition($this$module, factory_5);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = coreModule$lambda$lambda_6;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_6 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_6 = Kind_Factory_getInstance();
  var secondaryTypes_6 = emptyList();
  var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(ILocationRemoteSource), null, tmp2_3, kind_6, secondaryTypes_6);
  var factory_6 = new FactoryInstanceFactory(def_6);
  $this$module.p1c(factory_6);
  new KoinDefinition($this$module, factory_6);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = coreModule$lambda$lambda_7;
  var scopeQualifier_7 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_7 = Kind_Singleton_getInstance();
  var secondaryTypes_7 = emptyList();
  var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(LocationRepository), null, definition_2, kind_7, secondaryTypes_7);
  var factory_7 = new SingleInstanceFactory(def_7);
  $this$module.p1c(factory_7);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_7);
  }
  var tmp = new KoinDefinition($this$module, factory_7);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$36 = [getKClass(ILocationAccessor), getKClass(ILocationMutator)];
  binds(tmp, tmp$ret$36);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp33 = new TypeQualifier(getKClass(Department));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_3 = coreModule$lambda$lambda_8;
  var scopeQualifier_8 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_8 = Kind_Singleton_getInstance();
  var secondaryTypes_8 = emptyList();
  var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(IListLocalSource), tmp33, definition_3, kind_8, secondaryTypes_8);
  var factory_8 = new SingleInstanceFactory(def_8);
  $this$module.p1c(factory_8);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_8);
  }
  new KoinDefinition($this$module, factory_8);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp37 = new TypeQualifier(getKClass(ApiDepartment));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_4 = coreModule$lambda$lambda_9;
  var scopeQualifier_9 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_9 = Kind_Singleton_getInstance();
  var secondaryTypes_9 = emptyList();
  var def_9 = new BeanDefinition(scopeQualifier_9, getKClass(IListLocalSource), tmp37, definition_4, kind_9, secondaryTypes_9);
  var factory_9 = new SingleInstanceFactory(def_9);
  $this$module.p1c(factory_9);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_9);
  }
  new KoinDefinition($this$module, factory_9);
  var tmp41 = named('department_get_by_id');
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_5 = coreModule$lambda$lambda_10;
  var scopeQualifier_10 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_10 = Kind_Singleton_getInstance();
  var secondaryTypes_10 = emptyList();
  var def_10 = new BeanDefinition(scopeQualifier_10, getKClass(IListLocalSource), tmp41, definition_5, kind_10, secondaryTypes_10);
  var factory_10 = new SingleInstanceFactory(def_10);
  $this$module.p1c(factory_10);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_10);
  }
  new KoinDefinition($this$module, factory_10);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_4 = coreModule$lambda$lambda_11;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_11 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_11 = Kind_Factory_getInstance();
  var secondaryTypes_11 = emptyList();
  var def_11 = new BeanDefinition(scopeQualifier_11, getKClass(IDepartmentRemoteSource), null, tmp2_4, kind_11, secondaryTypes_11);
  var factory_11 = new FactoryInstanceFactory(def_11);
  $this$module.p1c(factory_11);
  new KoinDefinition($this$module, factory_11);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_6 = coreModule$lambda$lambda_12;
  var scopeQualifier_12 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_12 = Kind_Singleton_getInstance();
  var secondaryTypes_12 = emptyList();
  var def_12 = new BeanDefinition(scopeQualifier_12, getKClass(DepartmentRepository), null, definition_6, kind_12, secondaryTypes_12);
  var factory_12 = new SingleInstanceFactory(def_12);
  $this$module.p1c(factory_12);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_12);
  }
  var tmp_0 = new KoinDefinition($this$module, factory_12);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$57 = [getKClass(IDepartmentAccessor), getKClass(IDepartmentMutator), getKClass(IDepartmentInvalidator)];
  binds(tmp_0, tmp$ret$57);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp53 = new TypeQualifier(getKClass(Role));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_7 = coreModule$lambda$lambda_13;
  var scopeQualifier_13 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_13 = Kind_Singleton_getInstance();
  var secondaryTypes_13 = emptyList();
  var def_13 = new BeanDefinition(scopeQualifier_13, getKClass(IListLocalSource), tmp53, definition_7, kind_13, secondaryTypes_13);
  var factory_13 = new SingleInstanceFactory(def_13);
  $this$module.p1c(factory_13);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_13);
  }
  new KoinDefinition($this$module, factory_13);
  var tmp57 = named('role_get_by_id');
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_8 = coreModule$lambda$lambda_14;
  var scopeQualifier_14 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_14 = Kind_Singleton_getInstance();
  var secondaryTypes_14 = emptyList();
  var def_14 = new BeanDefinition(scopeQualifier_14, getKClass(IListLocalSource), tmp57, definition_8, kind_14, secondaryTypes_14);
  var factory_14 = new SingleInstanceFactory(def_14);
  $this$module.p1c(factory_14);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_14);
  }
  new KoinDefinition($this$module, factory_14);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_5 = coreModule$lambda$lambda_15;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_15 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_15 = Kind_Factory_getInstance();
  var secondaryTypes_15 = emptyList();
  var def_15 = new BeanDefinition(scopeQualifier_15, getKClass(IRoleRemoteSource), null, tmp2_5, kind_15, secondaryTypes_15);
  var factory_15 = new FactoryInstanceFactory(def_15);
  $this$module.p1c(factory_15);
  new KoinDefinition($this$module, factory_15);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_9 = coreModule$lambda$lambda_16;
  var scopeQualifier_16 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_16 = Kind_Singleton_getInstance();
  var secondaryTypes_16 = emptyList();
  var def_16 = new BeanDefinition(scopeQualifier_16, getKClass(RoleRepository), null, definition_9, kind_16, secondaryTypes_16);
  var factory_16 = new SingleInstanceFactory(def_16);
  $this$module.p1c(factory_16);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_16);
  }
  var tmp_1 = new KoinDefinition($this$module, factory_16);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$74 = [getKClass(IRoleAccessor), getKClass(IRoleMutator)];
  binds(tmp_1, tmp$ret$74);
  return Unit_instance;
}
function coreModule$lambda$lambda($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new ReferralRemoteSource(tmp$ret$0);
}
function coreModule$lambda$lambda_0($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IReferralRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new ReferralRepository(tmp, tmp$ret$1);
}
function coreModule$lambda$lambda_1($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('company_settings', tmp$ret$0);
}
function coreModule$lambda$lambda_2($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new CompanyRemoteSource(tmp$ret$0);
}
function coreModule$lambda$lambda_3($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(ICompanyRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(CompanySettings));
  var tmp$ret$3 = $this$factory.q1d(getKClass(ILocalSource), qualifier, null);
  return new CompanyRepository(tmp, tmp_0, tmp$ret$3);
}
function coreModule$lambda$lambda_4($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('locations', tmp$ret$0);
}
function coreModule$lambda$lambda_5($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('locations_get_by_id', tmp$ret$0);
}
function coreModule$lambda$lambda_6($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new LocationRemoteSource(tmp, tmp$ret$1);
}
function coreModule$lambda$lambda_7($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(Location));
  var tmp = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier_0 = named('location_get_by_id');
  var tmp_0 = $this$single.q1d(getKClass(IListLocalSource), qualifier_0, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(ILocationRemoteSource), null, null);
  return new LocationRepository(tmp, tmp_0, tmp$ret$3);
}
function coreModule$lambda$lambda_8($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('departments', tmp$ret$0);
}
function coreModule$lambda$lambda_9($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('departments_all', tmp$ret$0);
}
function coreModule$lambda$lambda_10($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('departments_get_by_id', tmp$ret$0);
}
function coreModule$lambda$lambda_11($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new DepartmentRemoteSource(tmp, tmp$ret$1);
}
function coreModule$lambda$lambda_12($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(Department));
  var tmp = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier_0 = new TypeQualifier(getKClass(ApiDepartment));
  var tmp_0 = $this$single.q1d(getKClass(IListLocalSource), qualifier_0, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier_1 = named('department_get_by_id');
  var tmp_1 = $this$single.q1d(getKClass(IListLocalSource), qualifier_1, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$5 = $this$single.q1d(getKClass(IDepartmentRemoteSource), null, null);
  return new DepartmentRepository(tmp, tmp_0, tmp_1, tmp$ret$5);
}
function coreModule$lambda$lambda_13($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('roles', tmp$ret$0);
}
function coreModule$lambda$lambda_14($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('roles_get_by_id', tmp$ret$0);
}
function coreModule$lambda$lambda_15($this$factory, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new RoleRemoteSource(tmp, tmp$ret$1);
}
function coreModule$lambda$lambda_16($this$single, it) {
  _init_properties_CoreModule_kt__is3d57();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(Role));
  var tmp = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier_0 = named('role_get_by_id');
  var tmp_0 = $this$single.q1d(getKClass(IListLocalSource), qualifier_0, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(IRoleRemoteSource), null, null);
  return new RoleRepository(tmp, tmp_0, tmp$ret$3);
}
var properties_initialized_CoreModule_kt_1qsvub;
function _init_properties_CoreModule_kt__is3d57() {
  if (!properties_initialized_CoreModule_kt_1qsvub) {
    properties_initialized_CoreModule_kt_1qsvub = true;
    coreModule = module_0(VOID, coreModule$lambda);
  }
}
function IDepartmentInvalidator() {
}
function ICompanyAccessor() {
}
function IDepartmentAccessor() {
}
function ILocationAccessor() {
}
function IReferralAccessor() {
}
function IRoleAccessor() {
}
function CompanySettings(startDayOfWeek) {
  this.i84_1 = startDayOfWeek;
}
protoOf(CompanySettings).toString = function () {
  return 'CompanySettings(startDayOfWeek=' + toString(this.i84_1) + ')';
};
protoOf(CompanySettings).hashCode = function () {
  return this.i84_1 == null ? 0 : this.i84_1.hashCode();
};
protoOf(CompanySettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CompanySettings))
    return false;
  var tmp0_other_with_cast = other instanceof CompanySettings ? other : THROW_CCE();
  if (!equals(this.i84_1, tmp0_other_with_cast.i84_1))
    return false;
  return true;
};
function Department(id, name, locationId, isDefault) {
  this.i7c_1 = id;
  this.j7c_1 = name;
  this.k7c_1 = locationId;
  this.l7c_1 = isDefault;
}
protoOf(Department).toString = function () {
  return 'Department(id=' + this.i7c_1.toString() + ', name=' + this.j7c_1 + ', locationId=' + this.k7c_1.toString() + ', isDefault=' + this.l7c_1 + ')';
};
protoOf(Department).hashCode = function () {
  var result = this.i7c_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.j7c_1) | 0;
  result = imul(result, 31) + this.k7c_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.l7c_1) | 0;
  return result;
};
protoOf(Department).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Department))
    return false;
  var tmp0_other_with_cast = other instanceof Department ? other : THROW_CCE();
  if (!this.i7c_1.equals(tmp0_other_with_cast.i7c_1))
    return false;
  if (!(this.j7c_1 === tmp0_other_with_cast.j7c_1))
    return false;
  if (!this.k7c_1.equals(tmp0_other_with_cast.k7c_1))
    return false;
  if (!(this.l7c_1 === tmp0_other_with_cast.l7c_1))
    return false;
  return true;
};
function Location(id, name, country, state, city, formattedAddress, timeZone, hash, mondayCloseTime, tuesdayCloseTime, wednesdayCloseTime, thursdayCloseTime, fridayCloseTime, saturdayCloseTime, sundayCloseTime, mondayOpenTime, tuesdayOpenTime, wednesdayOpenTime, thursdayOpenTime, fridayOpenTime, saturdayOpenTime, sundayOpenTime, mondayIsClosed, tuesdayIsClosed, wednesdayIsClosed, thursdayIsClosed, fridayIsClosed, saturdayIsClosed, sundayIsClosed, shiftFeedback, departmentBasedBudget) {
  this.y7e_1 = id;
  this.z7e_1 = name;
  this.a7f_1 = country;
  this.b7f_1 = state;
  this.c7f_1 = city;
  this.d7f_1 = formattedAddress;
  this.e7f_1 = timeZone;
  this.f7f_1 = hash;
  this.g7f_1 = mondayCloseTime;
  this.h7f_1 = tuesdayCloseTime;
  this.i7f_1 = wednesdayCloseTime;
  this.j7f_1 = thursdayCloseTime;
  this.k7f_1 = fridayCloseTime;
  this.l7f_1 = saturdayCloseTime;
  this.m7f_1 = sundayCloseTime;
  this.n7f_1 = mondayOpenTime;
  this.o7f_1 = tuesdayOpenTime;
  this.p7f_1 = wednesdayOpenTime;
  this.q7f_1 = thursdayOpenTime;
  this.r7f_1 = fridayOpenTime;
  this.s7f_1 = saturdayOpenTime;
  this.t7f_1 = sundayOpenTime;
  this.u7f_1 = mondayIsClosed;
  this.v7f_1 = tuesdayIsClosed;
  this.w7f_1 = wednesdayIsClosed;
  this.x7f_1 = thursdayIsClosed;
  this.y7f_1 = fridayIsClosed;
  this.z7f_1 = saturdayIsClosed;
  this.a7g_1 = sundayIsClosed;
  this.b7g_1 = shiftFeedback;
  this.c7g_1 = departmentBasedBudget;
}
protoOf(Location).toString = function () {
  return 'Location(id=' + this.y7e_1.toString() + ', name=' + this.z7e_1 + ', country=' + this.a7f_1 + ', state=' + this.b7f_1 + ', city=' + this.c7f_1 + ', formattedAddress=' + this.d7f_1 + ', timeZone=' + this.e7f_1 + ', hash=' + this.f7f_1 + ', mondayCloseTime=' + this.g7f_1 + ', tuesdayCloseTime=' + this.h7f_1 + ', wednesdayCloseTime=' + this.i7f_1 + ', thursdayCloseTime=' + this.j7f_1 + ', fridayCloseTime=' + this.k7f_1 + ', saturdayCloseTime=' + this.l7f_1 + ', sundayCloseTime=' + this.m7f_1 + ', mondayOpenTime=' + this.n7f_1 + ', tuesdayOpenTime=' + this.o7f_1 + ', wednesdayOpenTime=' + this.p7f_1 + ', thursdayOpenTime=' + this.q7f_1 + ', fridayOpenTime=' + this.r7f_1 + ', saturdayOpenTime=' + this.s7f_1 + ', sundayOpenTime=' + this.t7f_1 + ', mondayIsClosed=' + this.u7f_1 + ', tuesdayIsClosed=' + this.v7f_1 + ', wednesdayIsClosed=' + this.w7f_1 + ', thursdayIsClosed=' + this.x7f_1 + ', fridayIsClosed=' + this.y7f_1 + ', saturdayIsClosed=' + this.z7f_1 + ', sundayIsClosed=' + this.a7g_1 + ', shiftFeedback=' + this.b7g_1 + ', departmentBasedBudget=' + this.c7g_1 + ')';
};
protoOf(Location).hashCode = function () {
  var result = this.y7e_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.z7e_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.a7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.b7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.c7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.d7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.e7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.f7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.g7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.h7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.i7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.j7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.k7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.l7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.m7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.n7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.o7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.p7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.q7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.r7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.s7f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.t7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.u7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.v7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.w7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.x7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.y7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.z7f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.a7g_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.b7g_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.c7g_1) | 0;
  return result;
};
protoOf(Location).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Location))
    return false;
  var tmp0_other_with_cast = other instanceof Location ? other : THROW_CCE();
  if (!this.y7e_1.equals(tmp0_other_with_cast.y7e_1))
    return false;
  if (!(this.z7e_1 === tmp0_other_with_cast.z7e_1))
    return false;
  if (!(this.a7f_1 === tmp0_other_with_cast.a7f_1))
    return false;
  if (!(this.b7f_1 === tmp0_other_with_cast.b7f_1))
    return false;
  if (!(this.c7f_1 === tmp0_other_with_cast.c7f_1))
    return false;
  if (!(this.d7f_1 === tmp0_other_with_cast.d7f_1))
    return false;
  if (!(this.e7f_1 === tmp0_other_with_cast.e7f_1))
    return false;
  if (!(this.f7f_1 === tmp0_other_with_cast.f7f_1))
    return false;
  if (!(this.g7f_1 === tmp0_other_with_cast.g7f_1))
    return false;
  if (!(this.h7f_1 === tmp0_other_with_cast.h7f_1))
    return false;
  if (!(this.i7f_1 === tmp0_other_with_cast.i7f_1))
    return false;
  if (!(this.j7f_1 === tmp0_other_with_cast.j7f_1))
    return false;
  if (!(this.k7f_1 === tmp0_other_with_cast.k7f_1))
    return false;
  if (!(this.l7f_1 === tmp0_other_with_cast.l7f_1))
    return false;
  if (!(this.m7f_1 === tmp0_other_with_cast.m7f_1))
    return false;
  if (!(this.n7f_1 === tmp0_other_with_cast.n7f_1))
    return false;
  if (!(this.o7f_1 === tmp0_other_with_cast.o7f_1))
    return false;
  if (!(this.p7f_1 === tmp0_other_with_cast.p7f_1))
    return false;
  if (!(this.q7f_1 === tmp0_other_with_cast.q7f_1))
    return false;
  if (!(this.r7f_1 === tmp0_other_with_cast.r7f_1))
    return false;
  if (!(this.s7f_1 === tmp0_other_with_cast.s7f_1))
    return false;
  if (!(this.t7f_1 === tmp0_other_with_cast.t7f_1))
    return false;
  if (!(this.u7f_1 === tmp0_other_with_cast.u7f_1))
    return false;
  if (!(this.v7f_1 === tmp0_other_with_cast.v7f_1))
    return false;
  if (!(this.w7f_1 === tmp0_other_with_cast.w7f_1))
    return false;
  if (!(this.x7f_1 === tmp0_other_with_cast.x7f_1))
    return false;
  if (!(this.y7f_1 === tmp0_other_with_cast.y7f_1))
    return false;
  if (!(this.z7f_1 === tmp0_other_with_cast.z7f_1))
    return false;
  if (!(this.a7g_1 === tmp0_other_with_cast.a7g_1))
    return false;
  if (!(this.b7g_1 === tmp0_other_with_cast.b7g_1))
    return false;
  if (!(this.c7g_1 === tmp0_other_with_cast.c7g_1))
    return false;
  return true;
};
function Role(id, locationId, departmentId, name, color, stations) {
  this.o7i_1 = id;
  this.p7i_1 = locationId;
  this.q7i_1 = departmentId;
  this.r7i_1 = name;
  this.s7i_1 = color;
  this.t7i_1 = stations;
}
protoOf(Role).toString = function () {
  return 'Role(id=' + this.o7i_1.toString() + ', locationId=' + this.p7i_1.toString() + ', departmentId=' + toString(this.q7i_1) + ', name=' + this.r7i_1 + ', color=' + this.s7i_1 + ', stations=' + toString_0(this.t7i_1) + ')';
};
protoOf(Role).hashCode = function () {
  var result = this.o7i_1.hashCode();
  result = imul(result, 31) + this.p7i_1.hashCode() | 0;
  result = imul(result, 31) + (this.q7i_1 == null ? 0 : this.q7i_1.hashCode()) | 0;
  result = imul(result, 31) + getStringHashCode(this.r7i_1) | 0;
  result = imul(result, 31) + (this.s7i_1 == null ? 0 : getStringHashCode(this.s7i_1)) | 0;
  result = imul(result, 31) + hashCode(this.t7i_1) | 0;
  return result;
};
protoOf(Role).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Role))
    return false;
  var tmp0_other_with_cast = other instanceof Role ? other : THROW_CCE();
  if (!this.o7i_1.equals(tmp0_other_with_cast.o7i_1))
    return false;
  if (!this.p7i_1.equals(tmp0_other_with_cast.p7i_1))
    return false;
  if (!equals(this.q7i_1, tmp0_other_with_cast.q7i_1))
    return false;
  if (!(this.r7i_1 === tmp0_other_with_cast.r7i_1))
    return false;
  if (!(this.s7i_1 == tmp0_other_with_cast.s7i_1))
    return false;
  if (!equals(this.t7i_1, tmp0_other_with_cast.t7i_1))
    return false;
  return true;
};
function Station(id, stationNumber, name) {
  this.j84_1 = id;
  this.k84_1 = stationNumber;
  this.l84_1 = name;
}
protoOf(Station).toString = function () {
  return 'Station(id=' + this.j84_1.toString() + ', stationNumber=' + this.k84_1 + ', name=' + this.l84_1 + ')';
};
protoOf(Station).hashCode = function () {
  var result = this.j84_1.hashCode();
  result = imul(result, 31) + this.k84_1 | 0;
  result = imul(result, 31) + getStringHashCode(this.l84_1) | 0;
  return result;
};
protoOf(Station).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Station))
    return false;
  var tmp0_other_with_cast = other instanceof Station ? other : THROW_CCE();
  if (!this.j84_1.equals(tmp0_other_with_cast.j84_1))
    return false;
  if (!(this.k84_1 === tmp0_other_with_cast.k84_1))
    return false;
  if (!(this.l84_1 === tmp0_other_with_cast.l84_1))
    return false;
  return true;
};
function IDepartmentMutator() {
}
function ILocationMutator() {
}
function IRoleMutator() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_1).qz = typeParametersSerializers;
protoOf($serializer_2).qz = typeParametersSerializers;
protoOf($serializer_3).qz = typeParametersSerializers;
protoOf($serializer_4).qz = typeParametersSerializers;
protoOf($serializer_5).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
Companion_instance_2 = new Companion_0();
Companion_instance_3 = new Companion_1();
Companion_instance_4 = new Companion_2();
Companion_instance_5 = new Companion_3();
//endregion
//region block: exports
export {
  get_coreModule as get_coreModule65uf7gnve5b3,
  ICompanyAccessor as ICompanyAccessor1vx4gxjmpol6a,
  IDepartmentAccessor as IDepartmentAccessor2hj1il6ko3wqn,
  ILocationAccessor as ILocationAccessor2jiwvdkvuuw23,
  IReferralAccessor as IReferralAccessor2welacrzpx071,
  IRoleAccessor as IRoleAccessor21b6uyhytfsm9,
  IDepartmentMutator as IDepartmentMutator259k6elwb9x9i,
  ILocationMutator as ILocationMutator1vk25jv8ohj4j,
  IRoleMutator as IRoleMutator1wgry7o7me1av,
  IDepartmentInvalidator as IDepartmentInvalidator18hrqq7xwattt,
};
//endregion

